(function () {
if (window.__farDtfGangV54Loaded) return;
window.__farDtfGangV54Loaded = true;
function initRoot(root) {
if (!root || root.getAttribute('data-far-dtf-mounted') === 'true') return;
var configNode = root.querySelector('[data-far-dtf-config]');
if (!configNode) return;
var config;
try {
config = JSON.parse(configNode.textContent || '{}');
} catch (error) {
console.error('FAR DTF configuration could not be read.', error);
return;
}
root.setAttribute('data-far-dtf-mounted', 'true');
var sectionId = root.id;
var repeatGapInchesSetting = Number(config.repeatGapInches) || 0.5;
var edgeMarginInchesSetting = 0;
var defaultArtworkWidthInches = Number(config.defaultArtworkWidth) || 4;
var minimumArtworkSizeInches = 0.25;
var customSheetMinHeight = Number(config.customSheetMinHeight) || 12;
var customSheetMaxHeight = Number(config.customSheetMaxHeight) || 216;
var customSheetDefaultHeight = Number(config.customSheetDefaultHeight) || 36;
var customSheetMinimumPrice = Number(config.customSheetMinimumPrice) || 18;
var customSheetMinimumBillableHeight = Number(config.customSheetMinimumBillableHeight) || 36;
var customSheetPricePerHalfInch = Number(config.customSheetPricePerHalfInch) || 0.5;
function formatMoney(cents, moneyFormat) {
if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
return window.Shopify.formatMoney(cents, moneyFormat);
}
var amount = Number(cents || 0) / 100;
return '$' + amount.toFixed(2);
}
function calculateCustomHeightPrice(height) {
var customHeight = Number(height || 0);
var minimumPrice = Number(customSheetMinimumPrice || 18);
var minimumBillableHeight = Number(customSheetMinimumBillableHeight || 36);
var pricePerHalfInch = Number(customSheetPricePerHalfInch || 0.5);
if (!Number.isFinite(customHeight) || customHeight <= 0) {
return minimumPrice;
}
if (!Number.isFinite(minimumPrice) || minimumPrice < 0) {
minimumPrice = 18;
}
if (!Number.isFinite(minimumBillableHeight) || minimumBillableHeight <= 0) {
minimumBillableHeight = 36;
}
if (!Number.isFinite(pricePerHalfInch) || pricePerHalfInch <= 0) {
pricePerHalfInch = 0.5;
}
if (customHeight <= minimumBillableHeight) {
return minimumPrice;
}
return Math.max(minimumPrice, minimumPrice + (((customHeight - minimumBillableHeight) / 0.5) * pricePerHalfInch));
}
function fileExtension(filename) {
if (!filename || filename.indexOf('.') === -1) return '';
return filename.split('.').pop().toLowerCase();
}
function truncateFilename(filename) {
if (!filename) return 'Artwork uploaded';
if (filename.length <= 44) return filename;
var ext = fileExtension(filename);
var base = filename.replace(new RegExp('\\.' + ext + '$', 'i'), '');
return base.slice(0, 28) + '…' + (ext ? '.' + ext : '');
}
function revokePreviewUrl(root) {
if (root.dataset.farDtfPreviewUrl) {
window.URL.revokeObjectURL(root.dataset.farDtfPreviewUrl);
delete root.dataset.farDtfPreviewUrl;
}
delete root.dataset.farDtfLayoutUrl;
delete root.dataset.farDtfStableDataUrl;
delete root.dataset.farDtfProductionDataUrl;
delete root.dataset.farDtfSourceKind;
delete root.dataset.farDtfImageRatio;
delete root.dataset.farDtfTrimmedArtwork;
delete root.dataset.farDtfPreviewToken;
}
function getArtworkPreviewSource(root) {
return root.dataset.farDtfLayoutUrl || root.dataset.farDtfStableDataUrl || root.dataset.farDtfPreviewUrl || '';
}
function getArtworkSourceKind(root) {
if (root.dataset.farDtfLayoutUrl) return root.dataset.farDtfTrimmedArtwork === 'true' ? 'trimmed-data-url' : 'layout-data-url';
if (root.dataset.farDtfStableDataUrl) return 'stable-file-data-url';
if (root.dataset.farDtfPreviewUrl) return 'temporary-object-url';
return 'none';
}
function parseSheetSizeFromValue(value) {
if (!value) return null;
var normalized = String(value)
.replace(/×/g, 'x')
.replace(/\s+/g, ' ')
.trim();
var match = normalized.match(/(\d+(?:\.\d+)?)\s*(?:in|inch|inches|")?\s*x\s*(\d+(?:\.\d+)?)/i);
if (!match) return null;
var width = Number(match[1]);
var height = Number(match[2]);
if (!width || !height) return null;
return {
width: width,
height: height
};
}
function isCustomSheetEnabled(root) {
var toggle = root ? root.querySelector('[data-far-dtf-custom-sheet-toggle]') : null;
return Boolean(toggle && toggle.checked);
}
function getCustomSheetHeight(root) {
var input = root ? root.querySelector('[data-far-dtf-custom-height]') : null;
var raw = input ? Number(input.value) : 0;
if (!Number.isFinite(raw) || raw <= 0) return 0;
return Math.max(customSheetMinHeight, Math.min(customSheetMaxHeight, snapToHalfInch(raw)));
}
function getSelectedVariantSheetSize(root) {
var checkedOptions = root.querySelectorAll('[data-far-dtf-option-input]:checked');
var fallback = {
width: 22,
height: 36,
custom: false
};
for (var index = 0; index < checkedOptions.length; index += 1) {
var parsed = parseSheetSizeFromValue(checkedOptions[index].value);
if (parsed) {
parsed.custom = false;
return parsed;
}
}
return fallback;
}
function getSelectedSheetSize(root) {
var variantSize = getSelectedVariantSheetSize(root);
var customHeight = isCustomSheetEnabled(root) ? getCustomSheetHeight(root) : 0;
if (customHeight) {
return {
width: 22,
height: customHeight,
custom: true
};
}
return variantSize;
}
function getNumber(input) {
if (!input) return 0;
var value = Number(input.value);
return Number.isFinite(value) && value > 0 ? value : 0;
}
function enforceMinimumArtworkSize(input) {
if (!input) return;
var value = Number(input.value);
if (input.value !== '' && Number.isFinite(value) && value < minimumArtworkSizeInches) {
input.value = String(minimumArtworkSizeInches);
}
}
function cleanNumber(value, decimals) {
var number = Number(value || 0);
var precision = typeof decimals === 'number' ? decimals : 2;
if (!Number.isFinite(number)) return '0';
return number
.toFixed(precision)
.replace(/\.?0+$/, '');
}
function snapToHalfInch(value) {
var number = Number(value);
if (!Number.isFinite(number)) return 0;
return Math.round(number * 2) / 2;
}
function roundUpToHalfInch(value) {
var number = Number(value);
if (!Number.isFinite(number)) return 0;
return Math.ceil((number - 0.001) * 2) / 2;
}
function isHalfInchText(value) {
var normalized = String(value || '').trim();
if (!/^\d+(?:\.\d+)?$/.test(normalized)) return false;
var number = Number(normalized);
return Number.isFinite(number) && Math.abs((number * 2) - Math.round(number * 2)) < 0.001;
}
function halfInchOnlyMessage() {
return 'Use a whole- or half-inch height, such as 36, 36.5, or 37.';
}
function getSelectedGapInches(root) {
var gapInput = root.querySelector('[data-far-dtf-gap-input]');
var raw = gapInput && gapInput.value ? gapInput.value : repeatGapInchesSetting;
var parsed = parseFloat(String(raw).replace('in', '').trim());
if (!parsed || parsed < 0.25) return 0.5;
if (parsed > 2) return 2;
return parsed;
}
function getArtworkSize(root) {
var widthInput = root.querySelector('[data-far-dtf-artwork-width]');
var heightInput = root.querySelector('[data-far-dtf-artwork-height]');
var quantityInput = root.querySelector('[data-far-dtf-artwork-quantity]');
enforceMinimumArtworkSize(widthInput);
enforceMinimumArtworkSize(heightInput);
return {
width: getNumber(widthInput),
height: getNumber(heightInput),
quantity: Math.max(0, Math.floor(getNumber(quantityInput)))
};
}
function getSafeArea(sheet, edge) {
var safeWidth = Math.max(0, sheet.width - edge * 2);
var safeHeight = Math.max(0, sheet.height - edge * 2);
return {
width: safeWidth,
height: safeHeight
};
}
function getPixelsPerInch(root, artworkSheet) {
var size = getSelectedSheetSize(root);
var renderedWidth = artworkSheet ? artworkSheet.getBoundingClientRect().width : 0;
if (!renderedWidth || !size.width) return 0;
return renderedWidth / size.width;
}
function setTextAndClass(element, text, isWarning) {
if (!element) return;
element.textContent = text;
element.classList.toggle('is-warning', Boolean(isWarning));
}
function createRulerTicks(ruler, orientation, inches, pixelsPerInch) {
if (!ruler || !inches || !pixelsPerInch) return;
ruler.innerHTML = '';
var maxInches = Math.floor(inches);
var labelStep = inches > 180 ? 36 : inches > 108 ? 24 : inches > 36 ? 12 : 6;
for (var inch = 0; inch <= maxInches; inch += 1) {
var position = inch * pixelsPerInch;
var isMajor = inch % labelStep === 0 || inch === maxInches;
var tick = document.createElement('span');
tick.className = 'far-dtf-gang__ruler-tick' + (isMajor ? ' is-major' : '');
if (orientation === 'horizontal') {
tick.style.left = position.toFixed(2) + 'px';
} else {
tick.style.top = position.toFixed(2) + 'px';
}
ruler.appendChild(tick);
if (isMajor) {
var label = document.createElement('span');
label.className = 'far-dtf-gang__ruler-label';
label.textContent = inch + '"';
if (inch === 0) {
label.classList.add('is-start');
}
if (inch === maxInches) {
label.classList.add('is-end');
}
if (orientation === 'horizontal') {
label.style.left = position.toFixed(2) + 'px';
} else {
label.style.top = position.toFixed(2) + 'px';
}
ruler.appendChild(label);
}
}
}
function buildTrimmedPngPreview(objectUrl, maxPreviewWidthOverride) {
return new Promise(function (resolve, reject) {
var image = new Image();
image.onload = function () {
var naturalWidth = image.naturalWidth || image.width;
var naturalHeight = image.naturalHeight || image.height;
if (!naturalWidth || !naturalHeight) {
reject(new Error('Unable to read PNG artwork dimensions.'));
return;
}
var maxScanSize = 300;
var scanScale = Math.min(1, maxScanSize / Math.max(naturalWidth, naturalHeight));
var scanWidth = Math.max(1, Math.round(naturalWidth * scanScale));
var scanHeight = Math.max(1, Math.round(naturalHeight * scanScale));
var scanCanvas = document.createElement('canvas');
var scanContext = scanCanvas.getContext('2d', { willReadFrequently: true });
if (!scanContext) {
resolve({
url: objectUrl,
ratio: naturalWidth / naturalHeight,
trimmed: false,
originalWidth: naturalWidth,
originalHeight: naturalHeight,
trimWidth: naturalWidth,
trimHeight: naturalHeight,
message: 'Canvas trimming unavailable. Using full PNG bounds.'
});
return;
}
scanCanvas.width = scanWidth;
scanCanvas.height = scanHeight;
scanContext.clearRect(0, 0, scanWidth, scanHeight);
scanContext.drawImage(image, 0, 0, scanWidth, scanHeight);
var pixels;
try {
pixels = scanContext.getImageData(0, 0, scanWidth, scanHeight).data;
} catch (error) {
resolve({
url: objectUrl,
ratio: naturalWidth / naturalHeight,
trimmed: false,
originalWidth: naturalWidth,
originalHeight: naturalHeight,
trimWidth: naturalWidth,
trimHeight: naturalHeight,
message: 'Browser could not scan PNG transparency. Using full PNG bounds.'
});
return;
}
var minX = scanWidth;
var minY = scanHeight;
var maxX = -1;
var maxY = -1;
var alphaThreshold = 8;
for (var y = 0; y < scanHeight; y += 1) {
for (var x = 0; x < scanWidth; x += 1) {
var alpha = pixels[(y * scanWidth + x) * 4 + 3];
if (alpha > alphaThreshold) {
if (x < minX) minX = x;
if (y < minY) minY = y;
if (x > maxX) maxX = x;
if (y > maxY) maxY = y;
}
}
}
if (maxX < minX || maxY < minY) {
resolve({
url: objectUrl,
ratio: naturalWidth / naturalHeight,
trimmed: false,
originalWidth: naturalWidth,
originalHeight: naturalHeight,
trimWidth: naturalWidth,
trimHeight: naturalHeight,
message: 'PNG appears fully transparent. Using full PNG bounds.'
});
return;
}
var leftPct = minX / scanWidth;
var topPct = minY / scanHeight;
var rightPct = (maxX + 1) / scanWidth;
var bottomPct = (maxY + 1) / scanHeight;
var sourceX = Math.max(0, Math.floor(leftPct * naturalWidth));
var sourceY = Math.max(0, Math.floor(topPct * naturalHeight));
var sourceRight = Math.min(naturalWidth, Math.ceil(rightPct * naturalWidth));
var sourceBottom = Math.min(naturalHeight, Math.ceil(bottomPct * naturalHeight));
var trimWidth = Math.max(1, sourceRight - sourceX);
var trimHeight = Math.max(1, sourceBottom - sourceY);
var trimmed = trimWidth !== naturalWidth || trimHeight !== naturalHeight;
var previewMaxWidth = Number(maxPreviewWidthOverride || 1200);
var previewScale = Math.min(1, previewMaxWidth / trimWidth);
var previewWidth = Math.max(1, Math.round(trimWidth * previewScale));
var previewHeight = Math.max(1, Math.round(trimHeight * previewScale));
var trimCanvas = document.createElement('canvas');
var trimContext = trimCanvas.getContext('2d');
if (!trimContext) {
resolve({
url: objectUrl,
ratio: trimWidth / trimHeight,
trimmed: trimmed,
originalWidth: naturalWidth,
originalHeight: naturalHeight,
trimWidth: trimWidth,
trimHeight: trimHeight,
message: trimmed ? 'Transparent padding detected. Preview spacing is based on visible artwork bounds.' : 'PNG has no transparent padding to trim. Preview uses full visible bounds.'
});
return;
}
trimCanvas.width = previewWidth;
trimCanvas.height = previewHeight;
trimContext.clearRect(0, 0, previewWidth, previewHeight);
trimContext.drawImage(image, sourceX, sourceY, trimWidth, trimHeight, 0, 0, previewWidth, previewHeight);
resolve({
url: trimCanvas.toDataURL('image/png'),
ratio: trimWidth / trimHeight,
trimmed: trimmed,
originalWidth: naturalWidth,
originalHeight: naturalHeight,
trimWidth: trimWidth,
trimHeight: trimHeight,
message: trimmed
? 'Transparent padding detected with fast preflight. Preview spacing is based on visible artwork bounds. Original PNG remains attached for production.'
: 'PNG has no transparent padding to trim. Preview uses full visible bounds.'
});
};
image.onerror = function () {
reject(new Error('Unable to load PNG artwork for preview trimming.'));
};
image.src = objectUrl;
});
}
function inferPngSheetSizeFromPixelRatio(widthPx, heightPx) {
var pixelWidth = Number(widthPx || 0);
var pixelHeight = Number(heightPx || 0);
if (!Number.isFinite(pixelWidth) || !Number.isFinite(pixelHeight) || pixelWidth <= 0 || pixelHeight <= 0) {
return null;
}
var inferredHeight = (pixelHeight / pixelWidth) * 22;
var roundedHeight = roundUpToHalfInch(inferredHeight);
if (roundedHeight < customSheetMinHeight || roundedHeight > customSheetMaxHeight) {
return null;
}
return {
widthInches: 22,
heightInches: roundedHeight,
rawWidthInches: 22,
rawHeightInches: inferredHeight,
widthPx: pixelWidth,
heightPx: pixelHeight,
dpiX: pixelWidth / 22,
dpiY: pixelHeight / inferredHeight,
inferred: true,
inferredFromRatio: true,
roundedFromBrowserRatio: true
};
}
function inferPdfSheetSizeFromViewportRatio(viewportWidth, viewportHeight) {
var pageWidth = Number(viewportWidth || 0);
var pageHeight = Number(viewportHeight || 0);
if (!Number.isFinite(pageWidth) || !Number.isFinite(pageHeight) || pageWidth <= 0 || pageHeight <= 0) {
return null;
}
var physicalWidth = pageWidth / 72;
var physicalHeight = pageHeight / 72;
var inferredHeight = (pageHeight / pageWidth) * 22;
var roundedHeight = roundUpToHalfInch(inferredHeight);
if (roundedHeight < customSheetMinHeight || roundedHeight > customSheetMaxHeight) {
return null;
}
return {
width: 22,
height: roundedHeight,
rawWidth: Number.isFinite(physicalWidth) && physicalWidth > 0 ? physicalWidth : 22,
rawHeight: Number.isFinite(physicalHeight) && physicalHeight > 0 ? physicalHeight : inferredHeight,
normalizedHeight: inferredHeight,
source: 'PDF',
inferredFromViewportRatio: true,
roundedUpToHalfInch: Math.abs(inferredHeight - roundedHeight) > 0.001
};
}
function readPngPhysicalSize(file) {
return new Promise(function (resolve) {
if (!file || fileExtension(file.name) !== 'png' || !window.FileReader) {
resolve(null);
return;
}
var reader = new FileReader();
reader.onload = function () {
try {
var buffer = reader.result;
var view = new DataView(buffer);
var signature = [137, 80, 78, 71, 13, 10, 26, 10];
if (!view || view.byteLength < 33) {
resolve(null);
return;
}
for (var sigIndex = 0; sigIndex < signature.length; sigIndex += 1) {
if (view.getUint8(sigIndex) !== signature[sigIndex]) {
resolve(null);
return;
}
}
var offset = 8;
var widthPx = 0;
var heightPx = 0;
var pixelsPerUnitX = 0;
var pixelsPerUnitY = 0;
var unitSpecifier = 0;
while (offset + 12 <= view.byteLength) {
var length = view.getUint32(offset, false);
var type = '';
for (var typeIndex = 0; typeIndex < 4; typeIndex += 1) {
type += String.fromCharCode(view.getUint8(offset + 4 + typeIndex));
}
if (type === 'IHDR' && offset + 24 <= view.byteLength) {
widthPx = view.getUint32(offset + 8, false);
heightPx = view.getUint32(offset + 12, false);
}
if (type === 'pHYs' && offset + 21 <= view.byteLength) {
pixelsPerUnitX = view.getUint32(offset + 8, false);
pixelsPerUnitY = view.getUint32(offset + 12, false);
unitSpecifier = view.getUint8(offset + 16);
break;
}
if (type === 'IDAT' || type === 'IEND') break;
offset += 12 + length;
}
if (!widthPx || !heightPx) {
resolve(null);
return;
}
if (pixelsPerUnitX && pixelsPerUnitY && unitSpecifier === 1) {
var dpiX = pixelsPerUnitX * 0.0254;
var dpiY = pixelsPerUnitY * 0.0254;
if (dpiX && dpiY) {
var physicalSize = {
widthInches: widthPx / dpiX,
heightInches: heightPx / dpiY,
widthPx: widthPx,
heightPx: heightPx,
dpiX: dpiX,
dpiY: dpiY,
inferred: false,
inferredFromRatio: false
};
if (getDetectedSheetFromPhysicalSize('PNG', physicalSize.widthInches, physicalSize.heightInches)) {
resolve(physicalSize);
return;
}
}
}
var inferredDpi = widthPx / 22;
var commonDpi = [72, 96, 150, 200, 300, 600];
var matchedDpi = commonDpi.some(function (dpi) {
return Math.abs(inferredDpi - dpi) / dpi <= 0.035;
});
if (matchedDpi) {
resolve({
widthInches: widthPx / inferredDpi,
heightInches: heightPx / inferredDpi,
widthPx: widthPx,
heightPx: heightPx,
dpiX: inferredDpi,
dpiY: inferredDpi,
inferred: true,
inferredFromRatio: false
});
return;
}
resolve(inferPngSheetSizeFromPixelRatio(widthPx, heightPx));
} catch (error) {
resolve(null);
}
};
reader.onerror = function () {
resolve(null);
};
reader.readAsArrayBuffer(file.slice(0, 131072));
});
}
function initArtworkPreview(root) {
var input = root.querySelector('[data-far-dtf-upload-input]');
var uploadControl = root.querySelector('[data-far-dtf-upload-control]');
var uploadStatus = root.querySelector('[data-far-dtf-upload-status]');
var uploadTitle = root.querySelector('[data-far-dtf-upload-ui-title]');
var uploadText = root.querySelector('[data-far-dtf-upload-ui-text]');
var singleUpload = root.querySelector('[data-far-dtf-single-upload]');
var artworkSizePanel = root.querySelector('[data-far-dtf-artwork-size-panel]');
var repeatControls = root.querySelector('[data-far-dtf-repeat-controls]');
var repeatModeInput = root.querySelector('[data-far-dtf-repeat-mode]');
var gapInput = root.querySelector('[data-far-dtf-gap-input]');
var quantityInput = root.querySelector('[data-far-dtf-artwork-quantity]');
var quantityWrap = root.querySelector('[data-far-dtf-repeat-quantity-wrap]');
var artworkWidthInput = root.querySelector('[data-far-dtf-artwork-width]');
var artworkHeightInput = root.querySelector('[data-far-dtf-artwork-height]');
var heightOverrideInput = root.querySelector('[data-far-dtf-height-override]');
var autoHeightNote = root.querySelector('[data-far-dtf-auto-height-note]');
var estimate = root.querySelector('[data-far-dtf-estimate]');
var multiPanel = root.querySelector('[data-far-dtf-multi-panel]');
var pdfPanel = root.querySelector('[data-far-dtf-pdf-panel]');
var pdfInput = root.querySelector('[data-far-dtf-pdf-input]');
var pdfStatus = root.querySelector('[data-far-dtf-pdf-status]');
var pdfEstimate = root.querySelector('[data-far-dtf-pdf-estimate]');
var pdfHeight = root.querySelector('[data-far-dtf-pdf-height]');
var multiPanelEstimate = root.querySelector('[data-far-dtf-multi-panel-estimate]');
var multiFiles = root.querySelectorAll('[data-far-dtf-multi-file]');
var multiFields = root.querySelectorAll('[data-far-dtf-multi-field]');
var frame = root.querySelector('[data-far-dtf-preview-frame]');
var defaultPreview = root.querySelector('[data-far-dtf-default-preview]');
var preview = root.querySelector('[data-far-dtf-artwork-preview]');
var sheetStage = root.querySelector('[data-far-dtf-sheet-stage]');
var measureSystem = root.querySelector('[data-far-dtf-measure-system]');
var topRuler = root.querySelector('[data-far-dtf-top-ruler]');
var leftRuler = root.querySelector('[data-far-dtf-left-ruler]');
var previewImage = root.querySelector('[data-far-dtf-artwork-image]');
var pdfSheetImage = root.querySelector('[data-far-dtf-pdf-sheet-image]');
var repeatCanvas = root.querySelector('[data-far-dtf-repeat-canvas]');
var multiPlacementLayer = root.querySelector('[data-far-dtf-multi-placement-layer]');
var multiBoard = root.querySelector('[data-far-dtf-multi-board]');
var multiBoardList = root.querySelector('[data-far-dtf-multi-board-list]');
var multiEstimate = root.querySelector('[data-far-dtf-multi-estimate]');
var artworkSheet = root.querySelector('[data-far-dtf-artwork-sheet]');
var safeZone = root.querySelector('[data-far-dtf-safe-zone]');
var safeLabel = root.querySelector('[data-far-dtf-safe-label]');
var previewMetaLabel = root.querySelector('[data-far-dtf-preview-meta-label]');
var fallback = root.querySelector('[data-far-dtf-file-fallback]');
var fallbackType = root.querySelector('[data-far-dtf-file-type]');
var fallbackName = root.querySelector('[data-far-dtf-file-name]');
var fallbackMessage = root.querySelector('[data-far-dtf-file-message]');
var clearButton = root.querySelector('[data-far-dtf-clear-preview]');
var layoutInputs = root.querySelectorAll('[data-far-dtf-layout-input]');
var sourceInputs = root.querySelectorAll('[data-far-dtf-source-input]');
var sourcePanels = root.querySelectorAll('[data-far-dtf-source-panel]');
var sheetSizeSelects = root.querySelectorAll('[data-far-dtf-sheet-size-select]');
var artworkSizeProperty = root.querySelector('[data-far-dtf-artwork-size-property]');
var safeAreaProperty = root.querySelector('[data-far-dtf-print-area-property]');
var safeMarginProperty = root.querySelector('[data-far-dtf-safe-margin-property]');
var estimatedFitProperty = root.querySelector('[data-far-dtf-estimated-fit-property]');
var usageProperty = root.querySelector('[data-far-dtf-usage-property]');
var warningProperty = root.querySelector('[data-far-dtf-warning-property]');
var layoutProofInput = root.querySelector('[data-far-dtf-layout-proof-input]');
var layoutProofNoteProperty = root.querySelector('[data-far-dtf-layout-proof-note-property]');
var productionPdfInput = root.querySelector('[data-far-dtf-production-pdf-input]');
var productionPdfNoteProperty = root.querySelector('[data-far-dtf-production-pdf-note-property]');
var finalSheetSizeProperty = root.querySelector('[data-far-dtf-final-sheet-size-property]');
var autoDetectedSheetProperty = root.querySelector('[data-far-dtf-auto-detected-sheet-property]');
var dpiProperty = root.querySelector('[data-far-dtf-dpi-property]');
var pdfNoteProperty = root.querySelector('[data-far-dtf-pdf-note-property]');
var multiPlacementProperty = root.querySelector('[data-far-dtf-multi-placement-property]');
var dpiPanel = root.querySelector('[data-far-dtf-dpi-panel]');
var dpiText = root.querySelector('[data-far-dtf-dpi-text]');
var dpiApprovalInput = root.querySelector('[data-far-dtf-dpi-approval]');
var diagnosticProperty = root.querySelector('[data-far-dtf-diagnostic-property]');
var productForm = root.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"], form.far-dtf-gang__form');
var submitButton = root.querySelector('[data-far-dtf-submit]');
var submitText = root.querySelector('[data-far-dtf-submit-text]');
var defaultSubmitText = submitText ? submitText.textContent : config.addToCartLabel;
var defaultHelp = 'Transparent PNG only. Upload your artwork to begin.';
var customSheetToggle = root.querySelector('[data-far-dtf-custom-sheet-toggle]');
var customSheetWrap = root.querySelector('[data-far-dtf-custom-sheet]');
var customHeightInput = root.querySelector('[data-far-dtf-custom-height]');
var customSheetStatus = root.querySelector('[data-far-dtf-custom-sheet-status]');
var customPriceEstimate = root.querySelector('[data-far-dtf-custom-price-estimate]');
var customPriceValue = root.querySelector('[data-far-dtf-custom-price-value]');
var customPriceNote = root.querySelector('[data-far-dtf-custom-price-note]');
var customPriceProperty = root.querySelector('[data-far-dtf-custom-price-property]');
var customPriceNoteProperty = root.querySelector('[data-far-dtf-custom-price-note-property]');
var resizeTimer = null;
var isSubmittingWithProof = false;
var hasInvalidUpload = false;
var hasIncompleteMultiDetails = false;
var dimensionDriver = 'width';
var pdfObjectUrl = '';
var lastPdfRenderToken = '';
var lastPdfPreviewSignature = '';
var pdfPreviewInFlight = false;
var multiPreviewDataUrls = {};
var multiProductionDataUrls = {};
var multiPreviewRatios = {};
var multiPreviewTrimmed = {};
var isDraggingMultiTile = false;
if (multiBoard && sheetStage && measureSystem && artworkSheet && multiBoard.parentElement === artworkSheet) {
sheetStage.insertBefore(multiBoard, measureSystem.nextSibling);
}
if (!preview || !frame) return null;
function resetCustomPriceEstimate() {
if (customPriceEstimate) customPriceEstimate.classList.add('is-hidden');
if (customPriceProperty) customPriceProperty.value = '';
if (customPriceNoteProperty) customPriceNoteProperty.value = '';
}
function updateCustomPriceEstimate(height, valid) {
if (!customPriceEstimate || !customPriceValue || !customPriceNote) {
if (customPriceProperty) customPriceProperty.value = '';
if (customPriceNoteProperty) customPriceNoteProperty.value = '';
return;
}
if (!valid || !height) {
resetCustomPriceEstimate();
return;
}
var estimatedPrice = calculateCustomHeightPrice(height);
var estimatedCents = Math.round(estimatedPrice * 100);
var formattedEstimate = formatMoney(estimatedCents, config.moneyFormat);
var minimumPriceFormatted = formatMoney(Math.round(customSheetMinimumPrice * 100), config.moneyFormat);
var note;
if (height <= customSheetMinimumBillableHeight) {
note = 'Custom minimum-charge size selected. Sizes through 22 x ' + cleanNumber(customSheetMinimumBillableHeight, 1) + ' in use the existing minimum-price Shopify variant.';
} else {
note = 'Minimum ' + minimumPriceFormatted + ' through ' + cleanNumber(customSheetMinimumBillableHeight, 1) + ' in, then ' + formatMoney(Math.round(customSheetPricePerHalfInch * 100), config.moneyFormat) + ' per half inch. Checkout uses the matching Shopify variant.';
}
customPriceEstimate.classList.remove('is-hidden');
customPriceValue.textContent = formattedEstimate;
customPriceNote.textContent = note;
if (customPriceProperty) {
customPriceProperty.value = 'Custom height Shopify variant price reference: ' + formattedEstimate + ' for 22 x ' + cleanNumber(height, 1) + ' in';
}
if (customPriceNoteProperty) {
customPriceNoteProperty.value = height <= customSheetMinimumBillableHeight ? 'Custom minimum-charge height requested: 22 x ' + cleanNumber(height, 1) + ' in. Checkout uses the existing 22 x ' + cleanNumber(customSheetMinimumBillableHeight, 1) + ' in Shopify variant at the minimum charge: ' + minimumPriceFormatted + '.' : 'Whole- or half-inch custom height above the minimum uses the matching Shopify variant. Pricing rule: minimum ' + minimumPriceFormatted + ' through ' + cleanNumber(customSheetMinimumBillableHeight, 1) + ' in; then ' + formatMoney(Math.round(customSheetPricePerHalfInch * 100), config.moneyFormat) + ' per half inch.';
}
}
function updateCustomSheetState() {
if (!customSheetToggle || !customHeightInput) return { active: false, valid: true, height: 0 };
var active = Boolean(customSheetToggle.checked);
var rawText = String(customHeightInput.value || '').trim();
var value = Number(rawText);
var halfInchValue = Number.isFinite(value) ? snapToHalfInch(value) : 0;
var isHalfInch = isHalfInchText(rawText);
var invalidIncrement = rawText !== '' && Number.isFinite(value) && !isHalfInch;
var valid = !active || (rawText !== '' && isHalfInch && halfInchValue >= customSheetMinHeight && halfInchValue <= customSheetMaxHeight);
var partialBelowMinimum = Boolean(active && document.activeElement === customHeightInput && rawText !== '' && Number.isFinite(value) && value > 0 && value < customSheetMinHeight);
var variantSize = getSelectedVariantSheetSize(root);
var previewHeight = valid && active ? halfInchValue : variantSize.height;
customHeightInput.disabled = !active;
if (customSheetWrap) {
customSheetWrap.setAttribute('data-custom-active', active ? 'true' : 'false');
}
if (customSheetStatus) {
if (!active) {
customSheetStatus.textContent = 'Width remains locked at 22 in. Whole- and half-inch heights are accepted. Sizes through 22 x 36 use the minimum price; 22 x 36.5 and higher use matching Shopify variants.';
customSheetStatus.classList.remove('is-warning');
} else if (!valid) {
if (invalidIncrement) {
customSheetStatus.textContent = halfInchOnlyMessage();
customSheetStatus.classList.add('is-warning');
} else if (partialBelowMinimum) {
customSheetStatus.textContent = 'Keep entering the height. Valid minimum-charge custom sizes start at 22 x ' + cleanNumber(customSheetMinHeight, 0) + ' in.';
customSheetStatus.classList.remove('is-warning');
} else {
customSheetStatus.textContent = 'Enter a whole- or half-inch custom height from 22 x ' + cleanNumber(customSheetMinHeight, 1) + ' through 22 x ' + cleanNumber(customSheetMaxHeight, 1) + ' in before adding to cart.';
customSheetStatus.classList.add('is-warning');
}
} else {
customSheetStatus.textContent = previewHeight <= customSheetMinimumBillableHeight ? 'Custom sheet active: 22 x ' + cleanNumber(previewHeight, 1) + ' in. Minimum-charge custom size; checkout uses the existing 22 x ' + cleanNumber(customSheetMinimumBillableHeight, 1) + ' in variant.' : 'Custom sheet active: 22 x ' + cleanNumber(previewHeight, 1) + ' in. Checkout will use the matching Shopify variant price.';
customSheetStatus.classList.remove('is-warning');
}
}
updateCustomPriceEstimate(previewHeight, active && valid);
return {
active: active,
valid: valid,
height: active && valid ? halfInchValue : 0,
invalidIncrement: invalidIncrement,
isHalfInch: isHalfInch
};
}
function getDetectedSheetFromPhysicalSize(source, widthInches, heightInches) {
var width = Number(widthInches || 0);
var height = Number(heightInches || 0);
if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
return null;
}
var normalizedHeight = source === 'PDF' ? (height / width) * 22 : height;
var detectedHeight = roundUpToHalfInch(normalizedHeight);
var widthTolerance = source === 'PDF' ? 0.5 : 0.35;
if (source !== 'PDF' && Math.abs(width - 22) > widthTolerance) {
return null;
}
if (detectedHeight < customSheetMinHeight || detectedHeight > customSheetMaxHeight) {
return null;
}
return {
width: 22,
height: detectedHeight,
rawWidth: width,
rawHeight: height,
normalizedHeight: normalizedHeight,
source: source,
roundedUpToHalfInch: Math.abs(normalizedHeight - detectedHeight) > 0.001
};
}
function selectVisibleSheetOptionByHeight(height) {
var matched = false;
var targetHeight = Number(height || 0);
root.querySelectorAll('[data-far-dtf-option-input]').forEach(function (optionInput) {
var parsed = parseSheetSizeFromValue(optionInput.value);
if (!parsed || Math.abs(parsed.width - 22) > 0.001) return;
if (Math.abs(parsed.height - targetHeight) < 0.001) {
optionInput.checked = true;
optionInput.dispatchEvent(new Event('change', { bubbles: true }));
matched = true;
}
});
if (matched) {
syncSheetSizeSelectsFromRadios();
}
return matched;
}
function selectSingleLayoutForDetectedPng() {
if (selectedLayoutMode() === 'pdf') return;
layoutInputs.forEach(function (layoutInput) {
if (layoutInput.getAttribute('data-layout-mode') === 'single') {
layoutInput.checked = true;
layoutInput.dispatchEvent(new Event('change', { bubbles: true }));
}
});
}
function applyDetectedSheetSize(detected, filename) {
if (!detected || !detected.height) return false;
var standardMatched = selectVisibleSheetOptionByHeight(detected.height);
var message = detected.source + ' detected from uploaded file proportions as approximately ' + cleanNumber(detected.rawWidth, 2) + ' x ' + cleanNumber(detected.rawHeight, 2) + ' in. Sheet preview set to 22 x ' + cleanNumber(detected.height, 1) + ' in.';
root.dataset.farDtfDetectedSheetWidth = '22';
root.dataset.farDtfDetectedSheetHeight = String(detected.height);
root.dataset.farDtfDetectedSheetSource = detected.source;
root.dataset.farDtfDetectedSheetFile = filename || '';
root.dataset.farDtfDetectedFullSheet = 'true';
if (detected.source === 'PNG') {
selectSingleLayoutForDetectedPng();
if (artworkWidthInput) artworkWidthInput.value = '22';
if (artworkHeightInput) artworkHeightInput.value = cleanNumber(detected.height, 4);
if (heightOverrideInput) heightOverrideInput.checked = false;
}
if (standardMatched) {
if (customSheetToggle) customSheetToggle.checked = false;
if (customHeightInput) customHeightInput.disabled = true;
} else if (customSheetToggle && customHeightInput) {
customSheetToggle.checked = true;
customHeightInput.disabled = false;
customHeightInput.value = cleanNumber(detected.height, 1);
}
if (autoDetectedSheetProperty) {
autoDetectedSheetProperty.value = message + (filename ? ' / file: ' + filename : '');
}
if (customSheetStatus) {
customSheetStatus.textContent = message;
customSheetStatus.classList.remove('is-warning');
}
if (uploadStatus && detected.source === 'PNG') {
uploadStatus.textContent = message + ' Original PNG remains attached for production.';
}
if (pdfStatus && detected.source === 'PDF') {
pdfStatus.textContent = message + ' Original PDF remains attached for production.';
}
updateCustomSheetState();
renderSheetGeometry();
root.dispatchEvent(new CustomEvent('far-dtf:custom-sheet-change', { bubbles: true }));
return true;
}
function getImagePixelSizeFromSource(source) {
return new Promise(function (resolve) {
if (!source) {
resolve(null);
return;
}
var image = new Image();
image.onload = function () {
var widthPx = image.naturalWidth || image.width || 0;
var heightPx = image.naturalHeight || image.height || 0;
if (!widthPx || !heightPx) {
resolve(null);
return;
}
resolve({
widthPx: widthPx,
heightPx: heightPx,
widthInches: 22,
heightInches: (heightPx / widthPx) * 22,
dpiX: widthPx / 22,
dpiY: heightPx / ((heightPx / widthPx) * 22),
inferred: true,
inferredFromRatio: true,
inferredFromBrowserImage: true
});
};
image.onerror = function () {
resolve(null);
};
image.src = source;
});
}
function detectAndApplyImageSheetSize(file, source) {
return readPngPhysicalSize(file).then(function (metadataSize) {
var metadataDetected = metadataSize ? getDetectedSheetFromPhysicalSize('PNG', metadataSize.widthInches, metadataSize.heightInches) : null;
if (metadataDetected) {
return applyDetectedSheetSize(metadataDetected, file ? file.name : '');
}
return getImagePixelSizeFromSource(source).then(function (browserSize) {
var ratioSize = browserSize ? inferPngSheetSizeFromPixelRatio(browserSize.widthPx, browserSize.heightPx) : null;
if (!ratioSize) {
delete root.dataset.farDtfDetectedFullSheet;
return false;
}
var detected = {
width: 22,
height: ratioSize.heightInches,
rawWidth: ratioSize.rawWidthInches || 22,
rawHeight: ratioSize.rawHeightInches || ratioSize.heightInches,
source: 'PNG'
};
if (detected.height < customSheetMinHeight || detected.height > customSheetMaxHeight) {
delete root.dataset.farDtfDetectedFullSheet;
return false;
}
return applyDetectedSheetSize(detected, file ? file.name : '');
});
});
}
function detectAndApplyPngSheetSize(file) {
return detectAndApplyImageSheetSize(file, root.dataset.farDtfStableDataUrl || root.dataset.farDtfPreviewUrl || '');
}
function selectedLayoutMode() {
var checked = root.querySelector('[data-far-dtf-layout-input]:checked');
return checked ? checked.getAttribute('data-layout-mode') : 'single';
}

function setLayoutMode(mode) {
var targetMode = mode || 'single';
var matched = false;
layoutInputs.forEach(function (layoutInput) {
if (layoutInput.getAttribute('data-layout-mode') === targetMode) {
layoutInput.checked = true;
matched = true;
}
});
if (matched) {
layoutInputs.forEach(function (layoutInput) {
if (layoutInput.checked) {
layoutInput.dispatchEvent(new Event('change', { bubbles: true }));
}
});
}
return matched;
}
function syncSourceUIFromMode() {
var mode = selectedLayoutMode();
var sourceMode = mode === 'pdf' ? 'pdf' : 'png';
sourceInputs.forEach(function (sourceInput) {
sourceInput.checked = sourceInput.getAttribute('data-source-mode') === sourceMode;
});
sourcePanels.forEach(function (panel) {
panel.classList.toggle('is-hidden', panel.getAttribute('data-far-dtf-source-panel') !== sourceMode);
});
}
function syncSheetSizeSelectsFromRadios() {
sheetSizeSelects.forEach(function (select) {
var group = select.closest('[data-far-dtf-option-group]');
if (!group) return;
var checked = group.querySelector('[data-far-dtf-option-input]:checked');
if (checked && select.value !== checked.value) {
select.value = checked.value;
}
});
}
function selectSheetSizeFromDropdown(select) {
if (!select) return false;
var group = select.closest('[data-far-dtf-option-group]');
if (!group) return false;
var targetValue = String(select.value || '');
var matched = false;
group.querySelectorAll('[data-far-dtf-option-input]').forEach(function (optionInput) {
if (String(optionInput.value) === targetValue) {
optionInput.checked = true;
optionInput.dispatchEvent(new Event('change', { bubbles: true }));
matched = true;
}
});
return matched;
}
function selectedRepeatBehavior() {
return repeatModeInput && repeatModeInput.value ? repeatModeInput.value : 'Fill the entire sheet';
}
function isManualHeightOverride() {
return Boolean(heightOverrideInput && heightOverrideInput.checked);
}
function clearProductionProperties() {
if (artworkSizeProperty) artworkSizeProperty.value = '';
if (safeAreaProperty) safeAreaProperty.value = '';
if (safeMarginProperty) safeMarginProperty.value = '';
if (estimatedFitProperty) estimatedFitProperty.value = '';
if (usageProperty) usageProperty.value = '';
if (warningProperty) warningProperty.value = '';
if (layoutProofNoteProperty) layoutProofNoteProperty.value = '';
if (dpiProperty) dpiProperty.value = '';
if (pdfNoteProperty) pdfNoteProperty.value = '';
if (multiPlacementProperty) multiPlacementProperty.value = '';
if (productionPdfNoteProperty) productionPdfNoteProperty.value = '';
if (finalSheetSizeProperty) finalSheetSizeProperty.value = '';
if (autoDetectedSheetProperty) autoDetectedSheetProperty.value = '';
if (diagnosticProperty) diagnosticProperty.value = '';
if (layoutProofInput && window.DataTransfer) {
layoutProofInput.files = new DataTransfer().files;
}
if (productionPdfInput && window.DataTransfer) {
productionPdfInput.files = new DataTransfer().files;
}
}
function setProductionProperties(sizeText, safeAreaText, safeMarginText, fitText, usageText, warningText) {
var activeSheet = getSelectedSheetSize(root);
if (finalSheetSizeProperty) finalSheetSizeProperty.value = '22 x ' + cleanNumber(activeSheet.height, 2) + ' in' + (activeSheet.custom ? ' / custom height request' : '');
if (activeSheet.custom) {
updateCustomPriceEstimate(activeSheet.height, true);
} else {
resetCustomPriceEstimate();
}
if (artworkSizeProperty) artworkSizeProperty.value = sizeText || '';
if (safeAreaProperty) safeAreaProperty.value = safeAreaText || '';
if (safeMarginProperty) safeMarginProperty.value = safeMarginText || '';
if (estimatedFitProperty) estimatedFitProperty.value = fitText || '';
if (usageProperty) usageProperty.value = usageText || '';
if (warningProperty) warningProperty.value = warningText || '';
}
function getVisiblePixelWidth() {
var trimmedWidth = Number(root.dataset.farDtfTrimWidth || 0);
var originalWidth = Number(root.dataset.farDtfNaturalWidth || 0);
return trimmedWidth || originalWidth || 0;
}
function updateDpiPreflight() {
var mode = selectedLayoutMode();
var art = getArtworkSize(root);
var visiblePixels = getVisiblePixelWidth();
var dpi = art.width && visiblePixels ? visiblePixels / art.width : 0;
var hasPngPreview = Boolean(root.dataset.farDtfPreviewUrl);
var lowDpi = Boolean(mode !== 'multi' && mode !== 'pdf' && hasPngPreview && art.width && dpi && dpi < 150);
var approved = Boolean(dpiApprovalInput && dpiApprovalInput.checked);
if (mode === 'pdf' || mode === 'multi' || !hasPngPreview) {
if (dpiPanel) {
dpiPanel.classList.add('is-hidden');
}
if (mode === 'pdf' || mode === 'multi') {
if (dpiProperty) dpiProperty.value = '';
if (dpiApprovalInput) dpiApprovalInput.checked = false;
}
if (submitButton && !hasInvalidUpload) {
submitButton.disabled = false;
}
if (submitText && submitText.textContent === 'Approve resolution warning') {
submitText.textContent = defaultSubmitText;
}
return {
dpi: dpi,
low: false,
approved: true
};
}
if (dpiPanel) {
dpiPanel.classList.toggle('is-hidden', !lowDpi);
}
if (dpiText && lowDpi) {
dpiText.textContent = 'Estimated output is ' + Math.round(dpi) + ' DPI at ' + cleanNumber(art.width, 4) + ' in wide. FAR recommends 150 DPI or higher for cleaner DTF prints.';
}
if (dpiProperty) {
dpiProperty.value = dpi ? Math.round(dpi) + ' DPI estimated at selected print width' + (lowDpi ? ' / customer approval required' : ' / passed') : '';
}
if (submitButton) {
submitButton.disabled = lowDpi ? !approved : false;
}
if (submitText && lowDpi && !approved) {
submitText.textContent = 'Approve resolution warning';
}
if (submitText && (!lowDpi || approved) && submitText.textContent === 'Approve resolution warning') {
submitText.textContent = defaultSubmitText;
}
return {
dpi: dpi,
low: lowDpi,
approved: approved
};
}
function getRenderedRulerSize() {
if (!measureSystem) return 36;
var value = window.getComputedStyle(measureSystem).getPropertyValue('--far-dtf-ruler-size');
var parsed = parseFloat(value);
return parsed || 36;
}
function calculateFixedRenderedWidth(sheetWidth, sheetHeight) {
var stageWidth = sheetStage ? sheetStage.clientWidth : 0;
if (!stageWidth && frame) stageWidth = frame.clientWidth;
if (!stageWidth) stageWidth = root.clientWidth;
var rulerSize = getRenderedRulerSize();
var safeWidth = stageWidth ? stageWidth * 0.92 : 640;
var availableForSheet = Math.max(280, safeWidth - rulerSize - 32);
var baseWidth = Math.min(640, availableForSheet);
var compact = window.matchMedia('(max-width: 749px)').matches;
var maxRenderedHeight = compact ? 540 : 760;
var ratioLimitedWidth = sheetHeight > 0 ? maxRenderedHeight * sheetWidth / sheetHeight : baseWidth;
return Math.max(48, Math.min(baseWidth, ratioLimitedWidth));
}
function updatePreviewHeight(renderedSheetHeight) {
var rulerSize = getRenderedRulerSize();
var artPreviewInsetBuffer = 120;
var metaBuffer = 76;
var stagePaddingBuffer = 72;
var neededHeight = Math.ceil(renderedSheetHeight + rulerSize + artPreviewInsetBuffer + metaBuffer + stagePaddingBuffer);
var compact = window.matchMedia('(max-width: 749px)').matches;
var minimumHeight = compact ? 640 : 760;
var maximumHeight = compact ? 760 : 980;
var previewHeight = Math.min(maximumHeight, Math.max(minimumHeight, neededHeight));
root.style.setProperty('--far-dtf-preview-height', previewHeight + 'px');
}
function setPhysicalSheetVariables(sheet, pixelsPerInch) {
if (!artworkSheet || !pixelsPerInch) return;
var edge = edgeMarginInchesSetting;
var safeArea = getSafeArea(sheet, edge);
artworkSheet.style.setProperty('--far-dtf-inch-px', pixelsPerInch.toFixed(4) + 'px');
artworkSheet.style.setProperty('--far-dtf-half-inch-px', (pixelsPerInch / 2).toFixed(4) + 'px');
artworkSheet.style.setProperty('--far-dtf-quarter-inch-px', (pixelsPerInch / 4).toFixed(4) + 'px');
artworkSheet.style.setProperty('--far-dtf-safe-left', (edge * pixelsPerInch).toFixed(2) + 'px');
artworkSheet.style.setProperty('--far-dtf-safe-top', (edge * pixelsPerInch).toFixed(2) + 'px');
artworkSheet.style.setProperty('--far-dtf-safe-width', (safeArea.width * pixelsPerInch).toFixed(2) + 'px');
artworkSheet.style.setProperty('--far-dtf-safe-height', (safeArea.height * pixelsPerInch).toFixed(2) + 'px');
if (safeLabel) {
safeLabel.textContent = 'Print area: ' + cleanNumber(safeArea.width, 2) + ' x ' + cleanNumber(safeArea.height, 2);
}
}
function renderSheetGeometry() {
if (!artworkSheet || !sheetStage || !measureSystem) return;
updateCustomSheetState();
var size = getSelectedSheetSize(root);
var width = size.width || 22;
var height = size.height || 36;
var mode = selectedLayoutMode();
var renderedSheetWidth = calculateFixedRenderedWidth(width, height);
var pixelsPerInch = renderedSheetWidth / width;
var renderedSheetHeight = Math.round(height * pixelsPerInch);
var displayRatio = width / height;
updatePreviewHeight(renderedSheetHeight + (mode === 'multi' ? 330 : 0));
measureSystem.style.setProperty('--far-dtf-sheet-render-width', Math.floor(renderedSheetWidth) + 'px');
measureSystem.style.setProperty('--far-dtf-sheet-render-height', Math.floor(renderedSheetHeight) + 'px');
if (sheetStage) {
sheetStage.style.setProperty('--far-dtf-sheet-render-width', Math.floor(renderedSheetWidth) + 'px');
sheetStage.style.setProperty('--far-dtf-ruler-size', getRenderedRulerSize() + 'px');
}
artworkSheet.style.setProperty('--far-dtf-sheet-ratio', displayRatio);
artworkSheet.style.setProperty('--far-dtf-sheet-render-width', Math.floor(renderedSheetWidth) + 'px');
artworkSheet.style.setProperty('--far-dtf-sheet-render-height', Math.floor(renderedSheetHeight) + 'px');
setPhysicalSheetVariables(size, pixelsPerInch);
if (mode === 'pdf') {
artworkSheet.setAttribute('data-sheet-label', width + ' x ' + height + ' print-ready PDF preview');
if (safeZone) safeZone.classList.add('is-hidden');
if (height > 72) {
artworkSheet.setAttribute('data-long-sheet', 'true');
} else {
artworkSheet.removeAttribute('data-long-sheet');
}
if (layoutProofNoteProperty) {
layoutProofNoteProperty.value = 'No PNG layout proof generated for print-ready PDF workflow. Customer supplied a print-ready PDF for FAR production review.';
}
if (diagnosticProperty) {
diagnosticProperty.value = 'PDF mode: sheet geometry updated to selected physical size.';
}
} else if (mode === 'multi') {
artworkSheet.setAttribute('data-sheet-label', width + ' x ' + height + ' multi-design queue');
if (safeZone) safeZone.classList.add('is-hidden');
if (height > 72) {
artworkSheet.setAttribute('data-long-sheet', 'true');
} else {
artworkSheet.removeAttribute('data-long-sheet');
}
} else {
artworkSheet.setAttribute('data-sheet-label', width + ' x ' + height + ' sheet preview');
if (safeZone) safeZone.classList.remove('is-hidden');
if (height > 72) {
artworkSheet.setAttribute('data-long-sheet', 'true');
} else {
artworkSheet.removeAttribute('data-long-sheet');
}
}
createRulerTicks(topRuler, 'horizontal', width, pixelsPerInch);
createRulerTicks(leftRuler, 'vertical', height, pixelsPerInch);
}
function updateAutoHeightState() {
if (!artworkHeightInput) return;
var ratio = Number(root.dataset.farDtfImageRatio || 0);
var heightDriven = isManualHeightOverride();
if (ratio && artworkWidthInput && artworkHeightInput) {
if (!artworkWidthInput.value && !artworkHeightInput.value) {
artworkWidthInput.value = cleanNumber(Math.max(defaultArtworkWidthInches, minimumArtworkSizeInches), 4);
dimensionDriver = 'width';
}
enforceMinimumArtworkSize(artworkWidthInput);
enforceMinimumArtworkSize(artworkHeightInput);
var width = getNumber(artworkWidthInput);
var height = getNumber(artworkHeightInput);
artworkHeightInput.readOnly = !heightDriven;
artworkHeightInput.setAttribute('aria-readonly', artworkHeightInput.readOnly ? 'true' : 'false');
artworkHeightInput.classList.toggle('is-auto-calculated', !heightDriven);
if (heightDriven && dimensionDriver === 'height' && height) {
var autoWidth = Math.max(height * ratio, minimumArtworkSizeInches);
artworkWidthInput.value = cleanNumber(autoWidth, 4);
width = autoWidth;
} else if (width) {
var autoHeight = Math.max(width / ratio, minimumArtworkSizeInches);
artworkHeightInput.value = cleanNumber(autoHeight, 4);
height = autoHeight;
} else if (heightDriven && height) {
var fallbackWidth = Math.max(height * ratio, minimumArtworkSizeInches);
artworkWidthInput.value = cleanNumber(fallbackWidth, 4);
width = fallbackWidth;
}
if (autoHeightNote) {
if (heightDriven) {
autoHeightNote.textContent = 'Height-driven sizing is on. FAR preserves the visible PNG proportion and auto-calculates width: ' + cleanNumber(width, 4) + ' in W x ' + cleanNumber(height || getNumber(artworkHeightInput), 4) + ' in H.';
} else {
autoHeightNote.textContent = 'Auto height calculated from visible PNG artwork bounds: ' + cleanNumber(width, 4) + ' in W x ' + cleanNumber(height || getNumber(artworkHeightInput), 4) + ' in H.';
}
autoHeightNote.classList.add('is-active');
autoHeightNote.classList.remove('is-warning');
}
return;
}
enforceMinimumArtworkSize(artworkWidthInput);
enforceMinimumArtworkSize(artworkHeightInput);
artworkHeightInput.readOnly = false;
artworkHeightInput.setAttribute('aria-readonly', 'false');
artworkHeightInput.classList.remove('is-auto-calculated');
if (autoHeightNote) {
autoHeightNote.textContent = 'Upload a transparent PNG first. Once visible artwork bounds are detected, FAR keeps width and height proportional.';
autoHeightNote.classList.remove('is-active');
autoHeightNote.classList.remove('is-warning');
}
}
function scheduleSheetGeometry() {
window.requestAnimationFrame(function () {
renderSheetGeometry();
updateAutoHeightState();
window.requestAnimationFrame(function () {
renderSheetGeometry();
updateAutoHeightState();
applyCurrentPhysicalPreview();
});
});
}
function getAspectRatioWarning(art) {
var uploadedRatio = Number(root.dataset.farDtfImageRatio || 0);
if (!uploadedRatio || !art.width || !art.height) return '';
var requestedRatio = art.width / art.height;
var difference = Math.abs(requestedRatio - uploadedRatio) / uploadedRatio;
if (difference > 0.03) {
return '';
}
return '';
}
function placeSingleArtworkAtSafeOrigin(artPxW, artPxH, ppi) {
if (!previewImage) return;
var edgePx = edgeMarginInchesSetting * ppi;
previewImage.dataset.sizeMode = 'physical';
previewImage.dataset.distort = 'false';
previewImage.style.left = edgePx.toFixed(2) + 'px';
previewImage.style.top = edgePx.toFixed(2) + 'px';
previewImage.style.width = artPxW.toFixed(2) + 'px';
previewImage.style.height = artPxH.toFixed(2) + 'px';
previewImage.style.transform = 'none';
}
function applySingleArtworkSize() {
if (!previewImage || !artworkSheet) return;
updateAutoHeightState();
var sheet = getSelectedSheetSize(root);
var art = getArtworkSize(root);
var ppi = getPixelsPerInch(root, artworkSheet);
var edge = edgeMarginInchesSetting;
var safeArea = getSafeArea(sheet, edge);
var warning = '';
if (!getArtworkPreviewSource(root)) {
clearProductionProperties();
setTextAndClass(estimate, 'Upload transparent PNG artwork and enter width to calculate height from the uploaded PNG ratio. Default width is ' + cleanNumber(defaultArtworkWidthInches, 2) + ' in. Minimum design size is 0.25 in. Every major grid square equals 1 inch.', false);
return;
}
if (!art.width || !art.height || !ppi) {
previewImage.dataset.sizeMode = 'fallback';
previewImage.dataset.distort = 'false';
previewImage.style.width = '';
previewImage.style.height = '';
warning = 'Artwork width and height are needed for true-size preview.';
setProductionProperties(
'',
cleanNumber(safeArea.width, 2) + ' in W x ' + cleanNumber(safeArea.height, 2) + ' in H',
cleanNumber(edge, 2) + ' in on each edge',
'',
'',
warning
);
setTextAndClass(estimate, 'Enter artwork width. Height will auto-calculate when a PNG ratio is detected. Minimum design size is 0.25 in. Every major grid square equals 1 inch.', true);
return;
}
var visualWidth = Math.min(art.width, safeArea.width);
var visualHeight = Math.min(art.height, safeArea.height);
var artPxW = visualWidth * ppi;
var artPxH = visualHeight * ppi;
var safeAreaTotal = safeArea.width * safeArea.height;
var areaUsage = safeAreaTotal ? ((visualWidth * visualHeight) / safeAreaTotal) * 100 : 0;
var ratioWarning = isManualHeightOverride() ? getAspectRatioWarning(art) : '';
placeSingleArtworkAtSafeOrigin(artPxW, artPxH, ppi);
if (art.width > safeArea.width || art.height > safeArea.height) {
warning = 'Requested artwork exceeds the print area, so the visual preview is limited to the print boundary.';
}
if (ratioWarning) {
warning = warning ? warning + ' ' + ratioWarning : ratioWarning;
}
setProductionProperties(
cleanNumber(art.width, 4) + ' in W x ' + cleanNumber(art.height, 4) + ' in H',
cleanNumber(safeArea.width, 2) + ' in W x ' + cleanNumber(safeArea.height, 2) + ' in H',
cleanNumber(edge, 2) + ' in on each edge',
'1 copy placed from print-area origin',
areaUsage.toFixed(1) + '% estimated print-area usage',
warning
);
updateDpiPreflight();
setTextAndClass(
estimate,
'True-size box: ' + cleanNumber(art.width, 4) + ' in W x ' + cleanNumber(art.height, 4) + ' in H. First design starts at the print-area origin. Safe print area: ' + cleanNumber(safeArea.width, 2) + ' x ' + cleanNumber(safeArea.height, 2) + ' on a ' + sheet.width + ' x ' + sheet.height + ' sheet. Every major grid square equals 1 inch. Estimated print-area usage: ' + areaUsage.toFixed(1) + '%.' + (warning ? ' ' + warning : ''),
Boolean(warning)
);
}
function buildRepeatCanvas(objectUrl) {
if (!repeatCanvas || !objectUrl || !artworkSheet) return;
updateAutoHeightState();
var sheet = getSelectedSheetSize(root);
var art = getArtworkSize(root);
var ppi = getPixelsPerInch(root, artworkSheet);
var gap = getSelectedGapInches(root);
var edge = edgeMarginInchesSetting;
var safeArea = getSafeArea(sheet, edge);
var warning = '';
var ratioWarning = isManualHeightOverride() ? getAspectRatioWarning(art) : '';
repeatCanvas.innerHTML = '';
if (!art.width || !art.height || !ppi) {
setProductionProperties(
'',
cleanNumber(safeArea.width, 2) + ' in W x ' + cleanNumber(safeArea.height, 2) + ' in H',
cleanNumber(edge, 2) + ' in on each edge',
'',
'',
'Artwork width and height are needed for repeated preview.'
);
setTextAndClass(estimate, 'Enter artwork width. Height will auto-calculate when a PNG ratio is detected. Minimum design size is 0.25 in. Every major grid square equals 1 inch.', true);
return;
}
if (art.width > safeArea.width || art.height > safeArea.height) {
warning = 'This design is larger than the print area.';
}
if (ratioWarning) {
warning = warning ? warning + ' ' + ratioWarning : ratioWarning;
}
var cols = Math.floor((safeArea.width + gap) / (art.width + gap));
var rows = Math.floor((safeArea.height + gap) / (art.height + gap));
cols = Math.max(0, cols);
rows = Math.max(0, rows);
var capacity = cols * rows;
var repeatBehavior = selectedRepeatBehavior();
var requestedQuantity = art.quantity;
var placed = capacity;
if (repeatBehavior === 'Use exact requested quantity' && requestedQuantity > 0) {
placed = Math.min(capacity, requestedQuantity);
if (requestedQuantity > capacity) {
warning = warning ? warning + ' Requested quantity exceeds estimated print-area capacity.' : 'Requested quantity exceeds estimated print-area capacity.';
}
}
var artPxW = art.width * ppi;
var artPxH = art.height * ppi;
var gapPx = gap * ppi;
var edgePx = edge * ppi;
var placedCount = 0;
for (var row = 0; row < rows; row += 1) {
for (var col = 0; col < cols; col += 1) {
if (placedCount >= placed) break;
var tile = document.createElement('span');
var image = document.createElement('img');
tile.className = 'far-dtf-gang__repeat-tile';
tile.dataset.distort = 'false';
tile.dataset.debugLabel = 'T' + (placedCount + 1);
tile.style.left = (edgePx + col * (artPxW + gapPx)).toFixed(2) + 'px';
tile.style.top = (edgePx + row * (artPxH + gapPx)).toFixed(2) + 'px';
tile.style.width = artPxW.toFixed(2) + 'px';
tile.style.height = artPxH.toFixed(2) + 'px';
image.alt = '';
image.decoding = 'async';
image.loading = 'eager';
image.addEventListener('load', function () {
tile.dataset.imageLoaded = 'true';
});
image.addEventListener('error', function () {
tile.dataset.imageError = 'true';
if (diagnosticProperty) {
diagnosticProperty.value = 'Live repeat tile image failed to load from ' + getArtworkSourceKind(root) + '.';
}
});
image.src = objectUrl;
tile.appendChild(image);
repeatCanvas.appendChild(tile);
placedCount += 1;
}
}
var usedArea = placedCount * art.width * art.height;
var safeAreaTotal = safeArea.width * safeArea.height;
var usage = safeAreaTotal ? (usedArea / safeAreaTotal) * 100 : 0;
if (!capacity) {
warning = warning || 'No copies fit inside the print area with the selected size and spacing.';
}
var firstCopyText = '';
if (cols >= 1) {
var firstStartX = edge;
var firstStartY = edge;
var firstEndX = edge + art.width;
var firstEndY = edge + art.height;
firstCopyText = ' First copy starts at ' + cleanNumber(firstStartX, 4) + '" across and ' + cleanNumber(firstStartY, 4) + '" down, ending at ' + cleanNumber(firstEndX, 4) + '" x ' + cleanNumber(firstEndY, 4) + '".';
}
setProductionProperties(
cleanNumber(art.width, 4) + ' in W x ' + cleanNumber(art.height, 4) + ' in H',
cleanNumber(safeArea.width, 2) + ' in W x ' + cleanNumber(safeArea.height, 2) + ' in H',
cleanNumber(edge, 2) + ' in on each edge',
placedCount + ' of ' + capacity + ' possible copies inside safe area',
usage.toFixed(1) + '% estimated print-area usage',
warning
);
updateDpiPreflight();
setTextAndClass(
estimate,
'Estimated fit: ' + placedCount + ' design' + (placedCount === 1 ? '' : 's') + ' inside the print area of ' + cleanNumber(safeArea.width, 2) + ' x ' + cleanNumber(safeArea.height, 2) + ' on a ' + sheet.width + ' x ' + sheet.height + ' sheet. Artwork box: ' + cleanNumber(art.width, 4) + ' x ' + cleanNumber(art.height, 4) + ' in. Spacing: ' + gap + ' in. Across: ' + cols + '. Down: ' + rows + '. Every major grid square equals 1 inch.' + firstCopyText + ' Estimated print-area usage: ' + usage.toFixed(1) + '%.' + (warning ? ' ' + warning : ''),
Boolean(warning)
);
}
function readMultiPreviewDataUrl(fileInput, file) {
return new Promise(function (resolve) {
var slot = fileInput ? fileInput.getAttribute('data-slot-index') || '' : '';
if (!slot || !file || fileExtension(file.name) !== 'png' || !window.FileReader) {
resolve('');
return;
}
if (multiPreviewDataUrls[slot]) {
resolve(multiPreviewDataUrls[slot]);
return;
}
var reader = new FileReader();
reader.onload = function () {
var result = typeof reader.result === 'string' ? reader.result : '';
if (!result) {
resolve('');
return;
}
buildTrimmedPngPreview(result)
.then(function (trimmed) {
var previewUrl = trimmed && trimmed.url ? trimmed.url : result;
multiPreviewDataUrls[slot] = previewUrl;
multiPreviewRatios[slot] = Number(trimmed && trimmed.ratio ? trimmed.ratio : 0) || 1;
multiPreviewTrimmed[slot] = Boolean(trimmed && trimmed.trimmed);
resolve(previewUrl);
})
.catch(function () {
var probe = new Image();
probe.onload = function () {
multiPreviewDataUrls[slot] = result;
multiPreviewRatios[slot] = probe.naturalWidth && probe.naturalHeight ? probe.naturalWidth / probe.naturalHeight : 1;
multiPreviewTrimmed[slot] = false;
resolve(result);
};
probe.onerror = function () {
multiPreviewDataUrls[slot] = result;
multiPreviewRatios[slot] = 1;
multiPreviewTrimmed[slot] = false;
resolve(result);
};
probe.src = result;
});
};
reader.onerror = function () {
resolve('');
};
reader.readAsDataURL(file);
});
}
function syncMultiSlotProportionalSize(slotRoot, driver) {
if (!slotRoot) return;
var fileInput = slotRoot.querySelector('[data-far-dtf-multi-file]');
var widthInput = slotRoot.querySelector('[data-far-dtf-multi-width]');
var heightInput = slotRoot.querySelector('[data-far-dtf-multi-height]');
var quantityInput = slotRoot.querySelector('[data-far-dtf-multi-quantity]');
var slot = fileInput ? fileInput.getAttribute('data-slot-index') || '' : '';
var ratio = slot ? Number(multiPreviewRatios[slot] || 0) : 0;
var file = fileInput && fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
if (!file || fileExtension(file.name) !== 'png' || !ratio || !widthInput || !heightInput) return;
if (driver) {
slotRoot.dataset.farDtfMultiSizeDriver = driver;
}
var activeDriver = slotRoot.dataset.farDtfMultiSizeDriver || 'width';
var width = getNumber(widthInput);
var height = getNumber(heightInput);
if (!width && !height) {
width = Math.max(defaultArtworkWidthInches, minimumArtworkSizeInches);
widthInput.value = cleanNumber(width, 4);
activeDriver = 'width';
slotRoot.dataset.farDtfMultiSizeDriver = activeDriver;
}
if (!getNumber(quantityInput) && quantityInput && quantityInput.value === '') {
quantityInput.value = '1';
}
if (activeDriver === 'height' && height) {
width = Math.max(height * ratio, minimumArtworkSizeInches);
widthInput.value = cleanNumber(width, 4);
} else if (width) {
height = Math.max(width / ratio, minimumArtworkSizeInches);
heightInput.value = cleanNumber(height, 4);
} else if (height) {
width = Math.max(height * ratio, minimumArtworkSizeInches);
widthInput.value = cleanNumber(width, 4);
slotRoot.dataset.farDtfMultiSizeDriver = 'height';
}
widthInput.classList.add('is-auto-calculated');
heightInput.classList.add('is-auto-calculated');
}
function clampNumber(value, min, max) {
var number = Number(value || 0);
if (!Number.isFinite(number)) return min;
return Math.max(min, Math.min(max, number));
}
function enableMultiTileDrag(tile, xInput, yInput, artWidth, artHeight, ppi, printArea) {
if (!tile || !xInput || !yInput || !ppi || !printArea) return;
tile.addEventListener('pointerdown', function (event) {
if (event.button !== undefined && event.button !== 0) return;
isDraggingMultiTile = true;
tile.setPointerCapture(event.pointerId);
var startX = event.clientX;
var startY = event.clientY;
var startLeft = parseFloat(tile.style.left || '0') || 0;
var startTop = parseFloat(tile.style.top || '0') || 0;
var maxX = Math.max(0, printArea.width - artWidth);
var maxY = Math.max(0, printArea.height - artHeight);
function move(moveEvent) {
var nextLeftPx = startLeft + (moveEvent.clientX - startX);
var nextTopPx = startTop + (moveEvent.clientY - startY);
var nextX = clampNumber(nextLeftPx / ppi, 0, maxX);
var nextY = clampNumber(nextTopPx / ppi, 0, maxY);
tile.style.left = (nextX * ppi).toFixed(2) + 'px';
tile.style.top = (nextY * ppi).toFixed(2) + 'px';
xInput.value = cleanNumber(nextX, 2);
yInput.value = cleanNumber(nextY, 2);
}
function end(endEvent) {
isDraggingMultiTile = false;
try { tile.releasePointerCapture(endEvent.pointerId); } catch (error) {}
tile.removeEventListener('pointermove', move);
tile.removeEventListener('pointerup', end);
tile.removeEventListener('pointercancel', end);
updateMultiBoard();
}
tile.addEventListener('pointermove', move);
tile.addEventListener('pointerup', end);
tile.addEventListener('pointercancel', end);
});
}
function drawMultiPlacementTile(options) {
if (!multiPlacementLayer || !options || !options.src) return false;
var tile = document.createElement('button');
var image = document.createElement('img');
var label = document.createElement('span');
tile.type = 'button';
tile.className = 'far-dtf-gang__multi-placement-tile';
tile.style.left = options.leftPx.toFixed(2) + 'px';
tile.style.top = options.topPx.toFixed(2) + 'px';
tile.style.width = options.widthPx.toFixed(2) + 'px';
tile.style.height = options.heightPx.toFixed(2) + 'px';
tile.title = 'Artwork ' + options.slot + ' copy ' + options.copyIndex + ' / drag first copy or enter X/Y placement';
tile.setAttribute('aria-label', tile.title);
if (options.overflow) {
tile.classList.add('is-overflow');
}
image.alt = '';
image.decoding = 'async';
image.loading = 'eager';
image.src = options.src;
label.textContent = 'A' + options.slot + '.' + options.copyIndex;
tile.appendChild(image);
tile.appendChild(label);
multiPlacementLayer.appendChild(tile);
if (options.copyIndex === 1) {
enableMultiTileDrag(tile, options.xInput, options.yInput, options.widthIn, options.heightIn, options.ppi, options.printArea);
}
return true;
}
function updateMultiBoard() {
if (!multiBoard || !multiBoardList) return;
var sheet = getSelectedSheetSize(root);
var edge = edgeMarginInchesSetting;
var printArea = getSafeArea(sheet, edge);
var printAreaTotal = printArea.width * printArea.height;
var ppi = getPixelsPerInch(root, artworkSheet);
var gap = getSelectedGapInches(root);
var usedArea = 0;
var uploadedCount = 0;
var enteredCount = 0;
var invalidCount = 0;
var incompleteCount = 0;
var placedVisualCount = 0;
var overflowCount = 0;
var warning = '';
var blockingWarning = '';
var placementSummary = [];
var cursorX = 0;
var cursorY = 0;
var rowHeight = 0;
multiBoard.setAttribute('data-placement-mode', 'true');
multiBoardList.innerHTML = '';
if (multiPlacementLayer) {
multiPlacementLayer.innerHTML = '';
multiPlacementLayer.classList.remove('is-hidden');
}
multiFiles.forEach(function (fileInput) {
var file = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
var slot = fileInput.getAttribute('data-slot-index') || '';
var slotRoot = root.querySelector('[data-far-dtf-design-slot][data-slot-index="' + slot + '"]');
var widthInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-width]') : null;
var heightInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-height]') : null;
var quantityInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-quantity]') : null;
var xInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-x]') : null;
var yInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-y]') : null;
var isPng = Boolean(file && fileExtension(file.name) === 'png');
if (file && isPng && !multiPreviewDataUrls[slot]) {
readMultiPreviewDataUrl(fileInput, file).then(function () {
if (selectedLayoutMode() === 'multi' && !isDraggingMultiTile) {
updateMultiBoard();
}
});
}
if (file && isPng && multiPreviewRatios[slot]) {
syncMultiSlotProportionalSize(slotRoot);
}
enforceMinimumArtworkSize(widthInput);
enforceMinimumArtworkSize(heightInput);
var widthValueNumber = getNumber(widthInput);
var heightValueNumber = getNumber(heightInput);
var quantityValueNumber = Math.max(0, Math.floor(getNumber(quantityInput)));
var xValue = xInput && xInput.value !== '' ? Math.max(0, Number(xInput.value) || 0) : null;
var yValue = yInput && yInput.value !== '' ? Math.max(0, Number(yInput.value) || 0) : null;
var hasAnyEntry = Boolean(file || widthValueNumber || heightValueNumber || quantityValueNumber || xValue !== null || yValue !== null);
if (!hasAnyEntry) return;
enteredCount += 1;
var isInvalidFile = Boolean(file && !isPng);
var isIncomplete = Boolean(file && (!widthValueNumber || !heightValueNumber || !quantityValueNumber));
var isOversized = Boolean(widthValueNumber > printArea.width || heightValueNumber > printArea.height);
if (file) {
uploadedCount += 1;
}
if (isInvalidFile) {
invalidCount += 1;
blockingWarning = 'Only PNG files are accepted for multiple-design production.';
}
if (isIncomplete) {
incompleteCount += 1;
}
if (widthValueNumber && heightValueNumber && quantityValueNumber) {
usedArea += widthValueNumber * heightValueNumber * quantityValueNumber;
}
if (isOversized) {
warning = 'One or more designs may be larger than the selected print area.';
}
var item = document.createElement('div');
var thumb = document.createElement('div');
var copy = document.createElement('div');
var title = document.createElement('strong');
var meta = document.createElement('span');
var status = document.createElement('em');
item.className = 'far-dtf-gang__multi-board-item';
thumb.className = 'far-dtf-gang__multi-board-thumb';
copy.className = 'far-dtf-gang__multi-board-copy';
if (isInvalidFile) {
item.classList.add('is-error');
} else if (isIncomplete || isOversized) {
item.classList.add('is-warning');
}
if (file && isPng) {
var previewSrc = multiPreviewDataUrls[slot] || '';
if (!previewSrc) {
readMultiPreviewDataUrl(fileInput, file).then(function () {
if (selectedLayoutMode() === 'multi' && !isDraggingMultiTile) {
updateMultiBoard();
}
});
}
var image = document.createElement('img');
image.alt = '';
image.decoding = 'async';
image.loading = 'eager';
image.src = previewSrc || URL.createObjectURL(file);
image.addEventListener('load', function () {
if (image.src.indexOf('blob:') === 0) URL.revokeObjectURL(image.src);
});
thumb.appendChild(image);
if (previewSrc && widthValueNumber && heightValueNumber && quantityValueNumber && ppi) {
var artPxW = widthValueNumber * ppi;
var artPxH = heightValueNumber * ppi;
var manualStart = xValue !== null || yValue !== null;
var startX = manualStart ? clampNumber(xValue || 0, 0, Math.max(0, printArea.width - widthValueNumber)) : cursorX;
var startY = manualStart ? clampNumber(yValue || 0, 0, Math.max(0, printArea.height - heightValueNumber)) : cursorY;
for (var copyIndex = 1; copyIndex <= quantityValueNumber; copyIndex += 1) {
var placeX;
var placeY;
if (manualStart) {
var copiesPerRow = Math.max(1, Math.floor((printArea.width - startX + gap) / (widthValueNumber + gap)));
var localCol = (copyIndex - 1) % copiesPerRow;
var localRow = Math.floor((copyIndex - 1) / copiesPerRow);
placeX = startX + localCol * (widthValueNumber + gap);
placeY = startY + localRow * (heightValueNumber + gap);
} else {
if (cursorX + widthValueNumber > printArea.width && cursorX > 0) {
cursorX = 0;
cursorY += rowHeight + gap;
rowHeight = 0;
}
placeX = cursorX;
placeY = cursorY;
cursorX += widthValueNumber + gap;
rowHeight = Math.max(rowHeight, heightValueNumber);
}
var overflow = Boolean(placeX + widthValueNumber > printArea.width || placeY + heightValueNumber > printArea.height);
if (overflow) {
overflowCount += 1;
}
if (drawMultiPlacementTile({
src: previewSrc,
slot: slot,
copyIndex: copyIndex,
leftPx: (edge + placeX) * ppi,
topPx: (edge + placeY) * ppi,
widthPx: artPxW,
heightPx: artPxH,
widthIn: widthValueNumber,
heightIn: heightValueNumber,
xInput: xInput,
yInput: yInput,
ppi: ppi,
printArea: printArea,
overflow: overflow
})) {
placedVisualCount += 1;
}
if (copyIndex === 1) {
placementSummary.push('Artwork ' + slot + ': ' + cleanNumber(widthValueNumber, 4) + ' x ' + cleanNumber(heightValueNumber, 4) + ' in / qty ' + quantityValueNumber + ' / starts at X ' + cleanNumber(placeX, 2) + ' in, Y ' + cleanNumber(placeY, 2) + ' in');
}
}
}
} else {
var thumbLabel = document.createElement('span');
thumbLabel.textContent = file ? fileExtension(file.name).toUpperCase() : 'PNG';
thumb.appendChild(thumbLabel);
}
title.textContent = 'Artwork ' + slot + ' / ' + (file ? truncateFilename(file.name) : 'PNG needed');
var widthValue = widthValueNumber ? cleanNumber(widthValueNumber, 4) + ' in W' : 'width needed';
var heightValue = heightValueNumber ? cleanNumber(heightValueNumber, 4) + ' in H' : 'height needed';
var quantityValue = quantityValueNumber ? 'qty ' + quantityValueNumber : 'qty needed';
var placementValue = (xValue !== null || yValue !== null) ? ' / placed at X ' + cleanNumber(xValue || 0, 2) + ', Y ' + cleanNumber(yValue || 0, 2) : ' / auto placement';
meta.textContent = widthValue + ' x ' + heightValue + ' / ' + quantityValue + placementValue;
if (isInvalidFile) {
status.textContent = 'PNG required';
} else if (!file) {
status.textContent = 'file needed';
} else if (isIncomplete) {
status.textContent = 'complete size and quantity';
} else if (isOversized) {
status.textContent = 'review required';
} else {
status.textContent = 'visualized on sheet';
}
copy.appendChild(title);
copy.appendChild(meta);
copy.appendChild(status);
item.appendChild(thumb);
item.appendChild(copy);
multiBoardList.appendChild(item);
});
if (!multiBoardList.children.length) {
var empty = document.createElement('div');
empty.className = 'far-dtf-gang__multi-empty';
empty.textContent = 'Select transparent PNG files below to build the production request.';
multiBoardList.appendChild(empty);
}
var usage = printAreaTotal ? (usedArea / printAreaTotal) * 100 : 0;
if (usage > 100 || overflowCount > 0) {
warning = 'These designs may exceed the selected print area. Adjust size, quantity, spacing, or X/Y placement.';
}
hasInvalidUpload = Boolean(selectedLayoutMode() === 'multi' && invalidCount > 0);
hasIncompleteMultiDetails = Boolean(selectedLayoutMode() === 'multi' && (uploadedCount > 0 && incompleteCount > 0));
var estimateText = usedArea
? 'Estimated multi-design usage: ' + usage.toFixed(1) + '% of print area ' + cleanNumber(printArea.width, 2) + ' x ' + cleanNumber(printArea.height, 2) + ' on a ' + sheet.width + ' x ' + sheet.height + ' sheet. Uploaded files: ' + uploadedCount + '. Visual copies shown: ' + placedVisualCount + '.' + (blockingWarning ? ' ' + blockingWarning : '') + (hasIncompleteMultiDetails ? ' Complete each uploaded design with width, height, and quantity.' : '') + (warning ? ' ' + warning : '')
: uploadedCount
? 'Uploaded files: ' + uploadedCount + '. Enter final width, height, and quantity for each PNG so the sheet can show every design. Optional X/Y fields place the first copy; blank fields auto-arrange.' + (blockingWarning ? ' ' + blockingWarning : '')
: 'Add PNG artwork sizes and quantities to estimate total print-area usage. Minimum design size is 0.25 in.';
setTextAndClass(multiEstimate, estimateText, Boolean(warning || blockingWarning || hasIncompleteMultiDetails));
setTextAndClass(multiPanelEstimate, estimateText, Boolean(warning || blockingWarning || hasIncompleteMultiDetails));
if (multiPlacementProperty) {
multiPlacementProperty.value = placementSummary.join(' | ');
}
setProductionProperties(
uploadedCount ? 'Multiple PNG designs uploaded separately with visual placement preview' : 'Multiple PNG designs pending',
cleanNumber(printArea.width, 2) + ' in W x ' + cleanNumber(printArea.height, 2) + ' in H',
cleanNumber(edge, 2) + ' in on each edge',
uploadedCount + ' file' + (uploadedCount === 1 ? '' : 's') + ' uploaded / ' + enteredCount + ' design row' + (enteredCount === 1 ? '' : 's') + ' entered / ' + placedVisualCount + ' visual copy' + (placedVisualCount === 1 ? '' : 'ies') + ' shown',
usedArea ? usage.toFixed(1) + '% estimated print-area usage' : '',
blockingWarning || (hasIncompleteMultiDetails ? 'One or more uploaded designs is missing width, height, or quantity.' : warning)
);
if (submitButton && selectedLayoutMode() === 'multi') {
submitButton.disabled = Boolean(hasInvalidUpload || hasIncompleteMultiDetails);
}
if (submitText && selectedLayoutMode() === 'multi') {
if (hasInvalidUpload) {
submitText.textContent = 'Upload PNG only';
} else if (hasIncompleteMultiDetails) {
submitText.textContent = 'Complete design details';
} else {
submitText.textContent = defaultSubmitText;
}
}
}
function ensurePdfJs() {
return new Promise(function (resolve, reject) {
if (window.pdfjsLib) {
resolve(window.pdfjsLib);
return;
}
var existing = document.querySelector('script[data-far-pdfjs-loader]');
if (existing) {
existing.addEventListener('load', function () {
if (window.pdfjsLib) {
resolve(window.pdfjsLib);
} else {
reject(new Error('PDF renderer loaded but was unavailable.'));
}
});
existing.addEventListener('error', function () {
reject(new Error('PDF renderer failed to load.'));
});
return;
}
var script = document.createElement('script');
script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
script.async = true;
script.defer = true;
script.setAttribute('data-far-pdfjs-loader', 'true');
script.onload = function () {
if (!window.pdfjsLib) {
reject(new Error('PDF renderer unavailable after load.'));
return;
}
window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
resolve(window.pdfjsLib);
};
script.onerror = function () {
reject(new Error('PDF renderer failed to load.'));
};
document.head.appendChild(script);
});
}
function fileToArrayBuffer(file) {
return new Promise(function (resolve, reject) {
if (!file || !window.FileReader) {
reject(new Error('Unable to read PDF file.'));
return;
}
var reader = new FileReader();
reader.onload = function () {
resolve(reader.result);
};
reader.onerror = function () {
reject(new Error('Unable to read uploaded PDF.'));
};
reader.readAsArrayBuffer(file);
});
}

function decodePdfByteRange(buffer, start, end) {
try {
var slice = buffer.slice(start, end);
if (window.TextDecoder) {
return new TextDecoder('latin1').decode(slice);
}
var bytes = new Uint8Array(slice);
var output = '';
for (var index = 0; index < bytes.length; index += 1) {
output += String.fromCharCode(bytes[index]);
}
return output;
} catch (error) {
return '';
}
}
function findPdfPageBoxInText(text) {
if (!text) return null;
var pattern = /\/(MediaBox|CropBox)\s*\[\s*(-?\d+(?:\.\d+)?)\s+(-?\d+(?:\.\d+)?)\s+(-?\d+(?:\.\d+)?)\s+(-?\d+(?:\.\d+)?)/gi;
var fallback = null;
var match;
while ((match = pattern.exec(text)) !== null) {
var boxType = match[1];
var x1 = Number(match[2]);
var y1 = Number(match[3]);
var x2 = Number(match[4]);
var y2 = Number(match[5]);
var widthPts = Math.abs(x2 - x1);
var heightPts = Math.abs(y2 - y1);
if (!widthPts || !heightPts) continue;
var candidate = {
boxType: boxType,
widthPts: widthPts,
heightPts: heightPts
};
if (boxType === 'MediaBox') return candidate;
if (!fallback) fallback = candidate;
}
return fallback;
}
function getPdfSheetSizeFromBuffer(buffer) {
if (!buffer || !buffer.byteLength) return null;
var length = buffer.byteLength;
var headLength = Math.min(length, 1048576);
var tailStart = Math.max(0, length - 1048576);
var text = decodePdfByteRange(buffer, 0, headLength);
if (tailStart > headLength) {
text += '\n' + decodePdfByteRange(buffer, tailStart, length);
}
var pageBox = findPdfPageBoxInText(text);
if (!pageBox) return null;
var detected = inferPdfSheetSizeFromViewportRatio(pageBox.widthPts, pageBox.heightPts);
if (!detected) return null;
detected.rawWidth = pageBox.widthPts / 72;
detected.rawHeight = pageBox.heightPts / 72;
detected.pageBox = pageBox.boxType;
detected.detectedFromPdfBox = true;
return detected;
}
async function detectAndApplyPdfSheetSize(file) {
if (!file || fileExtension(file.name) !== 'pdf') return null;
try {
var buffer = await fileToArrayBuffer(file);
var detected = getPdfSheetSizeFromBuffer(buffer);
if (detected) {
applyDetectedSheetSize(detected, file.name);
return detected;
}
return null;
} catch (error) {
return null;
}
}

function getPdfFileSignature(file) {
if (!file) return '';
return [file.name || '', file.size || 0, file.lastModified || 0].join('|');
}
function clearNativePdfPreview() {
if (!artworkSheet) return;
Array.prototype.slice.call(artworkSheet.querySelectorAll('[data-far-dtf-pdf-native-frame]')).forEach(function (node) {
node.remove();
});
}
function renderNativePdfFallback(file) {
if (!file || !artworkSheet) return false;
try {
clearNativePdfPreview();
if (!pdfObjectUrl) {
 pdfObjectUrl = URL.createObjectURL(file);
}
var frame = document.createElement('object');
frame.className = 'far-dtf-gang__pdf-native-frame';
frame.setAttribute('data-far-dtf-pdf-native-frame', '');
frame.setAttribute('type', 'application/pdf');
frame.setAttribute('data', pdfObjectUrl + '#toolbar=0&navpanes=0&scrollbar=0&view=Fit');
frame.setAttribute('aria-label', 'Uploaded PDF native preview');
artworkSheet.appendChild(frame);
return true;
} catch (error) {
return false;
}
}
function promiseWithTimeout(promise, milliseconds, message) {
return new Promise(function (resolve, reject) {
var timer = window.setTimeout(function () {
reject(new Error(message || 'Timed out.'));
}, milliseconds);
promise.then(function (value) {
window.clearTimeout(timer);
resolve(value);
}).catch(function (error) {
window.clearTimeout(timer);
reject(error);
});
});
}

async function renderPdfFirstPageToSheet(file) {
if (!file || !pdfSheetImage) return false;
if (pdfPreviewInFlight) return false;
pdfPreviewInFlight = true;
var renderToken = String(Date.now());
lastPdfRenderToken = renderToken;
try {
if (pdfStatus) {
pdfStatus.textContent = 'PDF received. Rendering sheet preview...';
}
var buffer = await fileToArrayBuffer(file);
var boxDetectedPdfSheet = getPdfSheetSizeFromBuffer(buffer);
if (boxDetectedPdfSheet) {
applyDetectedSheetSize(boxDetectedPdfSheet, file.name);
}
var pdfjs = await ensurePdfJs();
var pdf = await pdfjs.getDocument({
data: buffer,
disableAutoFetch: true,
disableStream: true,
stopAtErrors: false
}).promise;
var page = await pdf.getPage(1);
if (lastPdfRenderToken !== renderToken) { pdfPreviewInFlight = false; return false; }
var viewport = page.getViewport({ scale: 1 });
var detectedPdfSheet = boxDetectedPdfSheet || getDetectedSheetFromPhysicalSize('PDF', viewport.width / 72, viewport.height / 72) || inferPdfSheetSizeFromViewportRatio(viewport.width, viewport.height);
if (detectedPdfSheet && !boxDetectedPdfSheet) {
applyDetectedSheetSize(detectedPdfSheet, file.name);
}
var sheet = getSelectedSheetSize(root);
var maxPreviewWidth = 900;
var maxPreviewHeight = 1800;
var maxPreviewPixels = 1200000;
var ratioWidth = Math.max(1, viewport.width);
var ratioHeight = Math.max(1, viewport.height);
var scaleByWidth = maxPreviewWidth / ratioWidth;
var scaleByHeight = maxPreviewHeight / ratioHeight;
var scaleByPixels = Math.sqrt(maxPreviewPixels / (ratioWidth * ratioHeight));
var scale = Math.min(scaleByWidth, scaleByHeight, scaleByPixels, 1.5);

if (!Number.isFinite(scale) || scale <= 0) {
throw new Error('PDF preview scale unavailable.');
}

var renderViewport = page.getViewport({ scale: scale });
var previewWidth = Math.max(1, Math.round(renderViewport.width));
var previewHeight = Math.max(1, Math.round(renderViewport.height));

if (previewWidth * previewHeight > maxPreviewPixels || previewWidth > 2200 || previewHeight > 2600) {
throw new Error('PDF preview skipped to protect browser memory.');
}

var canvas = document.createElement('canvas');
var context = canvas.getContext('2d', { alpha: false });
if (!context) {
throw new Error('Canvas unavailable for PDF preview.');
}
canvas.width = previewWidth;
canvas.height = previewHeight;
await promiseWithTimeout(page.render({
canvasContext: context,
viewport: renderViewport
}).promise, 8500, 'PDF preview render timed out.');
if (lastPdfRenderToken !== renderToken) return false;
clearNativePdfPreview();
pdfSheetImage.src = canvas.toDataURL('image/jpeg', 0.82);
pdfSheetImage.classList.remove('is-hidden');
if (previewMetaLabel) {
previewMetaLabel.textContent = 'Print-ready PDF sheet preview';
}
if (pdfStatus) {
pdfStatus.textContent = 'PDF preview loaded: ' + truncateFilename(file.name) + '. Sheet size was detected from the PDF page box/ratio and rounded up to the next half inch when needed. FAR will verify final dimensions before production.';
}
pdfPreviewInFlight = false;
return true;
} catch (error) {
if (lastPdfRenderToken !== renderToken) { pdfPreviewInFlight = false; return false; }
if (pdfSheetImage) {
pdfSheetImage.removeAttribute('src');
pdfSheetImage.classList.add('is-hidden');
}
if (pdfStatus) {
pdfStatus.textContent = 'PDF attached. Preview rendering was skipped or unavailable in this browser, but FAR will still receive the file for production review.';
}
var nativeFallbackRendered = renderNativePdfFallback(file);
if (pdfStatus) {
pdfStatus.textContent = nativeFallbackRendered ? 'PDF attached. Native browser preview shown. FAR will verify final dimensions before production.' : 'PDF attached. Preview rendering was skipped or unavailable in this browser, but FAR will still receive the file for production review.';
}
if (warningProperty) {
warningProperty.value = nativeFallbackRendered ? 'PDF canvas preview was unavailable; native browser PDF preview was used. Original PDF file was still attached for FAR review.' : 'PDF preview rendering was skipped or unavailable in browser. Original PDF file was still attached for FAR review.';
}
pdfPreviewInFlight = false;
return false;
}
}
function updatePdfMode() {
var sheet = getSelectedSheetSize(root);
var edge = edgeMarginInchesSetting;
var safeArea = getSafeArea(sheet, edge);
var file = pdfInput && pdfInput.files && pdfInput.files[0] ? pdfInput.files[0] : null;
var warning = '';
renderSheetGeometry();
if (pdfHeight) {
pdfHeight.textContent = cleanNumber(sheet.height, 2) + ' in';
}
if (pdfNoteProperty) {
pdfNoteProperty.value = 'Customer selected print-ready PDF workflow. PDF must be 22 in wide and match selected/custom sheet height: 22 x ' + cleanNumber(sheet.height, 2) + ' in.';
}
if (file && fileExtension(file.name) !== 'pdf') {
warning = 'Only PDF files are accepted in print-ready PDF mode.';
hasInvalidUpload = true;
} else {
hasInvalidUpload = false;
}
if (file && !warning && !pdfObjectUrl) {
pdfObjectUrl = URL.createObjectURL(file);
}
setProductionProperties(
file ? 'Print-ready PDF supplied by customer' : 'Print-ready PDF pending',
cleanNumber(safeArea.width, 2) + ' in W x ' + cleanNumber(safeArea.height, 2) + ' in H',
cleanNumber(edge, 2) + ' in on each edge',
file ? 'Designer-arranged PDF uploaded and previewed on selected sheet' : 'Awaiting print-ready PDF upload',
'Printer width locked at 22 in / selected sheet height ' + cleanNumber(sheet.height, 2) + ' in',
warning
);
setTextAndClass(
pdfEstimate,
file
? (warning || ('Print-ready PDF path selected. Preview is rendered on the ' + sheet.width + ' x ' + cleanNumber(sheet.height, 2) + ' gang sheet. FAR will verify dimensions before production.'))
: 'Upload the already-arranged PDF. The selected/custom sheet height controls the preview; width remains locked at 22 in.',
Boolean(warning)
);
if (defaultPreview) defaultPreview.classList.add('is-hidden');
if (preview) preview.classList.remove('is-hidden');
if (previewImage) {
previewImage.removeAttribute('src');
previewImage.classList.add('is-hidden');
}
if (repeatCanvas) {
repeatCanvas.innerHTML = '';
repeatCanvas.classList.add('is-hidden');
}
if (multiPlacementLayer) {
multiPlacementLayer.innerHTML = '';
multiPlacementLayer.classList.add('is-hidden');
}
if (multiBoard) {
multiBoard.classList.add('is-hidden');
multiBoard.removeAttribute('data-placement-mode');
}
if (fallback) {
fallback.classList.add('is-hidden');
}
frame.classList.add('has-artwork-preview');
if (!file) {
lastPdfPreviewSignature = '';
clearNativePdfPreview();
if (pdfSheetImage) {
pdfSheetImage.removeAttribute('src');
pdfSheetImage.classList.add('is-hidden');
}
if (pdfStatus) {
pdfStatus.textContent = 'Upload a print-ready PDF arranged at 22 in wide and ' + cleanNumber(sheet.height, 2) + ' in high.';
}
}
if (file && !warning) {
var pdfSignature = getPdfFileSignature(file) + '|sheet:' + cleanNumber(getSelectedSheetSize(root).height, 2);
if (pdfSignature !== lastPdfPreviewSignature && !pdfPreviewInFlight) {
lastPdfPreviewSignature = pdfSignature;
renderPdfFirstPageToSheet(file);
}
}
updateDpiPreflight();
}
function showMultiMode() {
if (defaultPreview) defaultPreview.classList.add('is-hidden');
frame.classList.add('has-artwork-preview');
preview.classList.remove('is-hidden');
if (previewImage) {
previewImage.removeAttribute('src');
previewImage.classList.add('is-hidden');
}
if (pdfSheetImage) {
pdfSheetImage.removeAttribute('src');
pdfSheetImage.classList.add('is-hidden');
}
if (repeatCanvas) {
repeatCanvas.innerHTML = '';
repeatCanvas.classList.add('is-hidden');
}
if (multiPlacementLayer) {
multiPlacementLayer.innerHTML = '';
multiPlacementLayer.classList.add('is-hidden');
}
if (fallback) fallback.classList.add('is-hidden');
if (multiBoard) multiBoard.classList.remove('is-hidden');
if (previewMetaLabel) previewMetaLabel.textContent = 'Multi-design production request';
updateMultiBoard();
scheduleSheetGeometry();
}
function applyCurrentPhysicalPreview() {
var mode = selectedLayoutMode();
updateAutoHeightState();
if (mode === 'pdf') {
updatePdfMode();
return;
}
if (mode === 'multi') {
updateMultiBoard();
return;
}
if (mode === 'repeat') {
if (root.dataset.farDtfPreviewUrl) {
buildRepeatCanvas(getArtworkPreviewSource(root));
}
return;
}
applySingleArtworkSize();
}
function setFormMode() {
var mode = selectedLayoutMode();
syncSourceUIFromMode();
syncSheetSizeSelectsFromRadios();
if (mode !== 'multi') {
hasIncompleteMultiDetails = false;
}
if (mode !== 'multi' && mode !== 'pdf') {
hasInvalidUpload = false;
}
if (singleUpload) {
singleUpload.classList.toggle('is-hidden', mode === 'multi');
}
if (input) {
input.disabled = mode === 'multi' || mode === 'pdf';
}
if (artworkSizePanel) {
artworkSizePanel.classList.toggle('is-hidden', mode === 'multi' || mode === 'pdf');
}
if (pdfPanel) {
pdfPanel.classList.toggle('is-hidden', mode !== 'pdf');
}
if (pdfInput) {
pdfInput.disabled = mode !== 'pdf';
}
if (repeatControls) {
repeatControls.classList.toggle('is-hidden', mode !== 'repeat');
}
if (gapInput) {
gapInput.disabled = mode !== 'repeat';
}
if (repeatModeInput) {
repeatModeInput.disabled = mode !== 'repeat';
}
if (quantityInput) {
quantityInput.disabled = mode !== 'repeat';
}
if (quantityWrap) {
quantityWrap.classList.toggle('is-hidden', mode !== 'repeat');
}
if (multiPanel) {
multiPanel.classList.toggle('is-hidden', mode !== 'multi');
}
multiFiles.forEach(function (fileInput) {
fileInput.disabled = mode !== 'multi';
});
multiFields.forEach(function (field) {
field.disabled = mode !== 'multi';
});
if (mode === 'pdf') {
hasIncompleteMultiDetails = false;
revokePreviewUrl(root);
if (multiBoard) multiBoard.classList.add('is-hidden');
if (multiPlacementLayer) {
multiPlacementLayer.innerHTML = '';
multiPlacementLayer.classList.add('is-hidden');
}
if (dpiPanel) dpiPanel.classList.add('is-hidden');
if (dpiApprovalInput) dpiApprovalInput.checked = false;
if (submitText && submitText.textContent === 'Approve resolution warning') submitText.textContent = defaultSubmitText;
if (submitButton && !hasInvalidUpload) submitButton.disabled = false;
renderSheetGeometry();
updatePdfMode();
return;
}
if (pdfSheetImage) {
pdfSheetImage.removeAttribute('src');
pdfSheetImage.classList.add('is-hidden');
}
if (mode === 'multi') {
revokePreviewUrl(root);
showMultiMode();
return;
}
if (multiBoard) {
multiBoard.classList.add('is-hidden');
multiBoard.removeAttribute('data-placement-mode');
}
if (multiPlacementLayer) {
multiPlacementLayer.innerHTML = '';
multiPlacementLayer.classList.add('is-hidden');
}
if (input && input.files && input.files[0]) {
refreshPreview();
return;
}
if (defaultPreview) defaultPreview.classList.remove('is-hidden');
frame.classList.remove('has-artwork-preview');
preview.classList.add('is-hidden');
clearProductionProperties();
scheduleSheetGeometry();
}
function resetPreview() {
revokePreviewUrl(root);
delete root.dataset.farDtfDetectedFullSheet;
delete root.dataset.farDtfDetectedSheetWidth;
delete root.dataset.farDtfDetectedSheetHeight;
delete root.dataset.farDtfDetectedSheetSource;
delete root.dataset.farDtfDetectedSheetFile;
hasInvalidUpload = false;
hasIncompleteMultiDetails = false;
if (input) input.value = '';
if (pdfInput) pdfInput.value = '';
if (pdfObjectUrl) { URL.revokeObjectURL(pdfObjectUrl); pdfObjectUrl = ''; }
lastPdfRenderToken = '';
multiFiles.forEach(function (fileInput) {
fileInput.value = '';
});
multiPreviewDataUrls = {};
multiProductionDataUrls = {};
multiPreviewRatios = {};
multiPreviewTrimmed = {};
if (heightOverrideInput) heightOverrideInput.checked = false;
if (artworkWidthInput) {
artworkWidthInput.value = '';
}
if (artworkHeightInput) {
artworkHeightInput.value = '';
artworkHeightInput.readOnly = false;
artworkHeightInput.classList.remove('is-auto-calculated');
}
if (uploadControl) uploadControl.classList.remove('has-file');
if (uploadTitle) uploadTitle.textContent = 'Upload transparent PNG';
if (uploadText) uploadText.textContent = 'Choose your artwork file. FAR will detect the visible bounds and build the physical preview.';
if (uploadStatus) uploadStatus.textContent = defaultHelp || '';
if (dpiApprovalInput) dpiApprovalInput.checked = false;
if (dpiPanel) dpiPanel.classList.add('is-hidden');
if (pdfSheetImage) {
pdfSheetImage.removeAttribute('src');
pdfSheetImage.classList.add('is-hidden');
}
if (selectedLayoutMode() === 'pdf') {
updatePdfMode();
return;
}
if (selectedLayoutMode() === 'multi') {
showMultiMode();
return;
}
frame.classList.remove('has-artwork-preview');
preview.classList.add('is-hidden');
if (defaultPreview) defaultPreview.classList.remove('is-hidden');
if (previewImage) {
previewImage.removeAttribute('src');
previewImage.classList.add('is-hidden');
previewImage.style.width = '';
previewImage.style.height = '';
previewImage.style.left = '';
previewImage.style.top = '';
previewImage.style.transform = '';
previewImage.dataset.distort = 'false';
}
if (repeatCanvas) {
repeatCanvas.innerHTML = '';
repeatCanvas.classList.add('is-hidden');
}
if (multiBoard) multiBoard.classList.add('is-hidden');
if (fallback) fallback.classList.add('is-hidden');
if (previewMetaLabel) previewMetaLabel.textContent = 'Artwork preview';
clearProductionProperties();
updateAutoHeightState();
setTextAndClass(estimate, 'Upload transparent PNG artwork and enter width to calculate height from the uploaded PNG ratio. Default width is ' + cleanNumber(defaultArtworkWidthInches, 2) + ' in. Minimum design size is 0.25 in. Every major grid square equals 1 inch.', false);
scheduleSheetGeometry();
}
function showFallback(file, message) {
var ext = fileExtension(file.name);
if (defaultPreview) defaultPreview.classList.add('is-hidden');
frame.classList.add('has-artwork-preview');
preview.classList.remove('is-hidden');
if (previewImage) {
previewImage.removeAttribute('src');
previewImage.classList.add('is-hidden');
}
if (pdfSheetImage) {
pdfSheetImage.removeAttribute('src');
pdfSheetImage.classList.add('is-hidden');
}
if (repeatCanvas) {
repeatCanvas.innerHTML = '';
repeatCanvas.classList.add('is-hidden');
}
if (multiBoard) multiBoard.classList.add('is-hidden');
if (fallback) fallback.classList.remove('is-hidden');
if (fallbackType) fallbackType.textContent = ext ? ext.toUpperCase() : 'FILE';
if (fallbackName) fallbackName.textContent = truncateFilename(file.name);
if (fallbackMessage) fallbackMessage.textContent = message || 'Only transparent PNG files are accepted for this product.';
if (previewMetaLabel) previewMetaLabel.textContent = 'Unsupported file type';
clearProductionProperties();
updateAutoHeightState();
scheduleSheetGeometry();
}
function readUploadedImageRatio(objectUrl) {
var token = String(Date.now());
root.dataset.farDtfPreviewToken = token;
buildTrimmedPngPreview(objectUrl)
.then(function (result) {
if (root.dataset.farDtfPreviewToken !== token) return;
var detectedFullSheet = root.dataset.farDtfDetectedFullSheet === 'true';
var detectedHeight = Number(root.dataset.farDtfDetectedSheetHeight || 0);
var fullSheetSource = root.dataset.farDtfStableDataUrl || objectUrl;
if (detectedFullSheet && detectedHeight) {
root.dataset.farDtfLayoutUrl = fullSheetSource;
root.dataset.farDtfSourceKind = 'detected-full-sheet-data-url';
root.dataset.farDtfImageRatio = String(22 / detectedHeight);
root.dataset.farDtfTrimmedArtwork = 'false';
root.dataset.farDtfNaturalWidth = String(result.originalWidth || 0);
root.dataset.farDtfNaturalHeight = String(result.originalHeight || 0);
root.dataset.farDtfTrimWidth = String(result.originalWidth || 0);
root.dataset.farDtfTrimHeight = String(result.originalHeight || 0);
} else {
root.dataset.farDtfLayoutUrl = result.url || objectUrl;
root.dataset.farDtfSourceKind = result.url && result.url.indexOf('data:image/') === 0 ? 'layout-data-url' : getArtworkSourceKind(root);
root.dataset.farDtfImageRatio = String(result.ratio || 1);
root.dataset.farDtfTrimmedArtwork = result.trimmed ? 'true' : 'false';
if (result.trimmed && result.url && result.url.indexOf('data:image/') === 0) { root.dataset.farDtfSourceKind = 'trimmed-data-url'; }
root.dataset.farDtfNaturalWidth = String(result.originalWidth || 0);
root.dataset.farDtfNaturalHeight = String(result.originalHeight || 0);
root.dataset.farDtfTrimWidth = String(result.trimWidth || result.originalWidth || 0);
root.dataset.farDtfTrimHeight = String(result.trimHeight || result.originalHeight || 0);
}
if (autoHeightNote && result.message) {
autoHeightNote.textContent = detectedFullSheet && detectedHeight ? 'Full 22 x ' + cleanNumber(detectedHeight, 1) + ' in PNG sheet detected from file proportions. Transparent space is preserved because this is a finished sheet layout.' : result.message;
autoHeightNote.classList.toggle('is-active', Boolean(detectedFullSheet || result.trimmed));
autoHeightNote.classList.toggle('is-warning', !detectedFullSheet && !result.trimmed);
}
updateAutoHeightState();
applyImagePreviewMode(getArtworkPreviewSource(root));
applyCurrentPhysicalPreview();
})
.catch(function () {
var probe = new Image();
probe.onload = function () {
if (root.dataset.farDtfPreviewToken !== token) return;
if (probe.naturalWidth && probe.naturalHeight) {
root.dataset.farDtfLayoutUrl = objectUrl;
root.dataset.farDtfImageRatio = String(probe.naturalWidth / probe.naturalHeight);
root.dataset.farDtfNaturalWidth = String(probe.naturalWidth || 0);
root.dataset.farDtfNaturalHeight = String(probe.naturalHeight || 0);
root.dataset.farDtfTrimWidth = String(probe.naturalWidth || 0);
root.dataset.farDtfTrimHeight = String(probe.naturalHeight || 0);
if (autoHeightNote) {
autoHeightNote.textContent = 'PNG transparency could not be trimmed in this browser. Preview is using the full uploaded PNG bounds.';
autoHeightNote.classList.add('is-warning');
autoHeightNote.classList.remove('is-active');
}
updateAutoHeightState();
applyImagePreviewMode(getArtworkPreviewSource(root));
applyCurrentPhysicalPreview();
}
};
probe.src = objectUrl;
});
}
function applyImagePreviewMode(objectUrl) {
var mode = selectedLayoutMode();
if (mode === 'pdf') {
updatePdfMode();
return;
}
if (mode === 'multi') {
showMultiMode();
return;
}
if (defaultPreview) defaultPreview.classList.add('is-hidden');
frame.classList.add('has-artwork-preview');
preview.classList.remove('is-hidden');
if (fallback) fallback.classList.add('is-hidden');
if (multiBoard) multiBoard.classList.add('is-hidden');
if (pdfSheetImage) {
pdfSheetImage.removeAttribute('src');
pdfSheetImage.classList.add('is-hidden');
}
scheduleSheetGeometry();
if (mode === 'repeat') {
if (previewImage) {
previewImage.removeAttribute('src');
previewImage.classList.add('is-hidden');
}
if (repeatCanvas) {
buildRepeatCanvas(objectUrl);
repeatCanvas.classList.remove('is-hidden');
}
if (previewMetaLabel) previewMetaLabel.textContent = 'Repeated sheet preview';
return;
}
if (repeatCanvas) {
repeatCanvas.innerHTML = '';
repeatCanvas.classList.add('is-hidden');
}
if (previewImage) {
previewImage.src = objectUrl;
previewImage.classList.remove('is-hidden');
}
if (previewMetaLabel) previewMetaLabel.textContent = 'True-size artwork preview';
window.requestAnimationFrame(applySingleArtworkSize);
}
function fileToDataUrl(file) {
return new Promise(function (resolve, reject) {
if (!file || !window.FileReader) {
reject(new Error('FileReader is not available.'));
return;
}
var reader = new FileReader();
reader.onload = function () {
var result = typeof reader.result === 'string' ? reader.result : '';
if (!result) {
reject(new Error('Unable to create stable artwork data URL.'));
return;
}
resolve(result);
};
reader.onerror = function () {
reject(new Error('Unable to read uploaded PNG artwork.'));
};
reader.readAsDataURL(file);
});
}
function showImagePreview(file) {
revokePreviewUrl(root);
var objectUrl = window.URL.createObjectURL(file);
var token = String(Date.now());
root.dataset.farDtfPreviewToken = token;
root.dataset.farDtfPreviewUrl = objectUrl;
root.dataset.farDtfSourceKind = 'temporary-object-url-pending-data-url';
if (uploadText) {
uploadText.textContent = 'PNG received. Creating stable artwork preview source...';
}
fileToDataUrl(file)
.then(function (dataUrl) {
if (root.dataset.farDtfPreviewToken !== token) return;
root.dataset.farDtfStableDataUrl = dataUrl;
root.dataset.farDtfSourceKind = 'stable-file-data-url';
delete root.dataset.farDtfProductionDataUrl;
detectAndApplyImageSheetSize(file, dataUrl).then(function (detectedFullSheet) {
if (detectedFullSheet) {
root.dataset.farDtfProductionDataUrl = dataUrl;
} else {
buildTrimmedPngPreview(dataUrl, 6000)
.then(function (production) {
root.dataset.farDtfProductionDataUrl = production && production.url ? production.url : dataUrl;
})
.catch(function () {
root.dataset.farDtfProductionDataUrl = dataUrl;
});
}
if (diagnosticProperty) {
diagnosticProperty.value = detectedFullSheet ? 'Stable artwork data URL created. Full-sheet PNG proportions detected; transparent sheet space preserved.' : 'Stable artwork data URL created from uploaded PNG before preview/proof generation.';
}
readUploadedImageRatio(dataUrl);
applyImagePreviewMode(dataUrl);
});
})
.catch(function () {
if (root.dataset.farDtfPreviewToken !== token) return;
root.dataset.farDtfSourceKind = 'temporary-object-url-fallback';
if (diagnosticProperty) {
diagnosticProperty.value = 'FileReader failed. Falling back to temporary object URL for preview/proof.';
}
detectAndApplyImageSheetSize(file, objectUrl).then(function () {
readUploadedImageRatio(objectUrl);
applyImagePreviewMode(objectUrl);
});
});
}
function refreshPreview() {
var mode = selectedLayoutMode();
scheduleSheetGeometry();
if (mode === 'pdf') {
updatePdfMode();
return;
}
if (mode === 'multi') {
showMultiMode();
return;
}
if (!input) return;
var file = input.files && input.files[0] ? input.files[0] : null;
if (!file || !root.dataset.farDtfPreviewUrl) {
applyCurrentPhysicalPreview();
return;
}
var ext = fileExtension(file.name);
var mime = file.type || '';
var isPreviewableImage = mime.indexOf('image/') === 0 && ext === 'png';
if (isPreviewableImage) {
applyImagePreviewMode(getArtworkPreviewSource(root));
}
}
function loadImageForProof(src) {
return new Promise(function (resolve, reject) {
if (!src) {
reject(new Error('No PNG artwork source was available for the layout proof.'));
return;
}
var image = new Image();
image.onload = function () {
if (typeof image.decode === 'function') {
image.decode()
.then(function () {
resolve(image);
})
.catch(function () {
resolve(image);
});
return;
}
resolve(image);
};
image.onerror = function () {
if (diagnosticProperty) {
diagnosticProperty.value = 'Proof image failed to load from ' + getArtworkSourceKind(root) + '.';
}
reject(new Error('Unable to load PNG artwork image for layout proof.'));
};
image.src = src;
if (image.complete && (image.naturalWidth || image.width)) {
image.onload();
}
});
}
function canvasToPngFile(canvas, filename) {
return new Promise(function (resolve, reject) {
if (!canvas.toBlob) {
reject(new Error('Canvas export is not supported in this browser.'));
return;
}
var activeSheet = getSelectedSheetSize(root);
var canvasPixels = Number(canvas.width || 0) * Number(canvas.height || 0);
var shouldCompressProof = Boolean(
activeSheet.custom ||
activeSheet.height > 36 ||
canvasPixels > 1600000
);
var mimeType = shouldCompressProof ? 'image/jpeg' : 'image/png';
var finalName = shouldCompressProof
? filename.replace(/\.png$/i, '.jpg')
: filename;
var quality = shouldCompressProof ? 0.72 : undefined;
canvas.toBlob(function (blob) {
if (!blob) {
reject(new Error('Unable to create layout proof file.'));
return;
}
resolve(new File([blob], finalName, { type: mimeType }));
}, mimeType, quality);
});
}
function attachProofFile(file) {
if (!layoutProofInput || !file || !window.DataTransfer) return false;
var transfer = new DataTransfer();
transfer.items.add(file);
layoutProofInput.files = transfer.files;
return layoutProofInput.files && layoutProofInput.files.length > 0;
}
function appendProofWarning(message) {
if (!warningProperty || !message) return;
if (warningProperty.value) {
if (warningProperty.value.indexOf(message) === -1) {
warningProperty.value = warningProperty.value + ' ' + message;
}
} else {
warningProperty.value = message;
}
}
function getProofCanvasSize(sheet) {
var width;
if (sheet.height <= 36) {
width = 1100;
} else if (sheet.height <= 72) {
width = 900;
} else {
width = 660;
}
return {
width: width,
height: Math.round(width * (sheet.height / sheet.width))
};
}
function drawProofGrid(ctx, canvasWidth, canvasHeight, sheet) {
var ppi = canvasWidth / sheet.width;
var quarter = ppi / 4;
ctx.fillStyle = '#041936';
ctx.fillRect(0, 0, canvasWidth, canvasHeight);
ctx.strokeStyle = 'rgba(232, 221, 199, 0.11)';
ctx.lineWidth = 1;
for (var qx = 0; qx <= canvasWidth; qx += quarter) {
ctx.beginPath();
ctx.moveTo(qx, 0);
ctx.lineTo(qx, canvasHeight);
ctx.stroke();
}
for (var qy = 0; qy <= canvasHeight; qy += quarter) {
ctx.beginPath();
ctx.moveTo(0, qy);
ctx.lineTo(canvasWidth, qy);
ctx.stroke();
}
ctx.strokeStyle = 'rgba(232, 221, 199, 0.32)';
ctx.lineWidth = 1;
for (var ix = 0; ix <= canvasWidth; ix += ppi) {
ctx.beginPath();
ctx.moveTo(ix, 0);
ctx.lineTo(ix, canvasHeight);
ctx.stroke();
}
for (var iy = 0; iy <= canvasHeight; iy += ppi) {
ctx.beginPath();
ctx.moveTo(0, iy);
ctx.lineTo(canvasWidth, iy);
ctx.stroke();
}
return ppi;
}
function roundedRect(ctx, x, y, width, height, radius) {
var r = Math.min(radius, width / 2, height / 2);
ctx.beginPath();
ctx.moveTo(x + r, y);
ctx.lineTo(x + width - r, y);
ctx.quadraticCurveTo(x + width, y, x + width, y + r);
ctx.lineTo(x + width, y + height - r);
ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
ctx.lineTo(x + r, y + height);
ctx.quadraticCurveTo(x, y + height, x, y + height - r);
ctx.lineTo(x, y + r);
ctx.quadraticCurveTo(x, y, x + r, y);
ctx.closePath();
}
function drawDiagnosticPill(ctx, x, y, text, fill, ink) {
return { width: 0, height: 0 };
}
function drawProofLabel(ctx, sheet, diagnosticLines) {
return;
}
function drawSafeArea(ctx, ppi, sheet, edge) {
var x = edge * ppi;
var y = edge * ppi;
var width = Math.max(0, (sheet.width - edge * 2) * ppi);
var height = Math.max(0, (sheet.height - edge * 2) * ppi);
ctx.save();
ctx.strokeStyle = 'rgba(243, 214, 92, 0.95)';
ctx.setLineDash([12, 8]);
ctx.lineWidth = 3;
ctx.strokeRect(x, y, width, height);
ctx.restore();
}
function drawCheckerboard(ctx, x, y, width, height, cell) {
var size = Math.max(4, cell || 10);
ctx.save();
ctx.beginPath();
ctx.rect(x, y, width, height);
ctx.clip();
for (var yy = y; yy < y + height; yy += size) {
for (var xx = x; xx < x + width; xx += size) {
var even = (Math.floor((xx - x) / size) + Math.floor((yy - y) / size)) % 2 === 0;
ctx.fillStyle = even ? 'rgba(232, 221, 199, 0.92)' : 'rgba(4, 25, 54, 0.92)';
ctx.fillRect(xx, yy, size, size);
}
}
ctx.restore();
}
function drawProofArtwork(ctx, image, x, y, width, height, label) {
if (!ctx || !image || !width || !height) return false;
ctx.save();
ctx.beginPath();
ctx.rect(x, y, width, height);
ctx.clip();
ctx.drawImage(image, x, y, width, height);
ctx.restore();
return true;
}
function drawSourceSample(ctx, image, canvasWidth, canvasHeight) {
return;
}
async function generateMultiDesignLayoutProof() {
if (!layoutProofInput) return false;
updateMultiBoard();
var sheet = getSelectedSheetSize(root);
var edge = edgeMarginInchesSetting;
var printArea = getSafeArea(sheet, edge);
var gap = getSelectedGapInches(root);
var canvasSize = getProofCanvasSize(sheet);
var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
if (!ctx) {
appendProofWarning('Customer layout proof was not generated because canvas rendering was unavailable.');
if (diagnosticProperty) diagnosticProperty.value = 'Multi-layout proof failed: canvas unavailable.';
return false;
}
canvas.width = canvasSize.width;
canvas.height = canvasSize.height;
var ppi = drawProofGrid(ctx, canvas.width, canvas.height, sheet);
var edgePx = edge * ppi;
var cursorX = 0;
var cursorY = 0;
var rowHeight = 0;
var uploadedCount = 0;
var drawnCount = 0;
var placedCount = 0;
var overflowCount = 0;
var placementLines = [];
drawSafeArea(ctx, ppi, sheet, edge);
for (var index = 0; index < multiFiles.length; index += 1) {
var fileInput = multiFiles[index];
var file = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
var slot = fileInput.getAttribute('data-slot-index') || String(index + 1);
var slotRoot = root.querySelector('[data-far-dtf-design-slot][data-slot-index="' + slot + '"]');
var widthInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-width]') : null;
var heightInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-height]') : null;
var quantityInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-quantity]') : null;
var xInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-x]') : null;
var yInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-y]') : null;
if (file && fileExtension(file.name) === 'png') {
await readMultiPreviewDataUrl(fileInput, file);
syncMultiSlotProportionalSize(slotRoot);
}
var widthValueNumber = getNumber(widthInput);
var heightValueNumber = getNumber(heightInput);
var quantityValueNumber = Math.max(0, Math.floor(getNumber(quantityInput)));
var xValue = xInput && xInput.value !== '' ? Math.max(0, Number(xInput.value) || 0) : null;
var yValue = yInput && yInput.value !== '' ? Math.max(0, Number(yInput.value) || 0) : null;
if (!file || fileExtension(file.name) !== 'png' || !widthValueNumber || !heightValueNumber || !quantityValueNumber) {
continue;
}
uploadedCount += 1;
var src = await readMultiPreviewDataUrl(fileInput, file);
if (!src) continue;
var image;
try {
image = await loadImageForProof(src);
} catch (error) {
appendProofWarning('Customer layout proof could not load one or more multi-design PNG files.');
continue;
}
var artPxW = widthValueNumber * ppi;
var artPxH = heightValueNumber * ppi;
var manualStart = xValue !== null || yValue !== null;
var startX = manualStart ? clampNumber(xValue || 0, 0, Math.max(0, printArea.width - widthValueNumber)) : cursorX;
var startY = manualStart ? clampNumber(yValue || 0, 0, Math.max(0, printArea.height - heightValueNumber)) : cursorY;
for (var copyIndex = 1; copyIndex <= quantityValueNumber; copyIndex += 1) {
var placeX;
var placeY;
if (manualStart) {
var copiesPerRow = Math.max(1, Math.floor((printArea.width - startX + gap) / (widthValueNumber + gap)));
var localCol = (copyIndex - 1) % copiesPerRow;
var localRow = Math.floor((copyIndex - 1) / copiesPerRow);
placeX = startX + localCol * (widthValueNumber + gap);
placeY = startY + localRow * (heightValueNumber + gap);
} else {
if (cursorX + widthValueNumber > printArea.width && cursorX > 0) {
cursorX = 0;
cursorY += rowHeight + gap;
rowHeight = 0;
}
placeX = cursorX;
placeY = cursorY;
cursorX += widthValueNumber + gap;
rowHeight = Math.max(rowHeight, heightValueNumber);
}
var overflow = Boolean(placeX + widthValueNumber > printArea.width || placeY + heightValueNumber > printArea.height);
if (overflow) {
overflowCount += 1;
}
placedCount += 1;
if (drawProofArtwork(ctx, image, edgePx + placeX * ppi, edgePx + placeY * ppi, artPxW, artPxH, 'A' + slot + '.' + copyIndex)) {
drawnCount += 1;
}
if (copyIndex === 1) {
placementLines.push('Artwork ' + slot + ': ' + cleanNumber(widthValueNumber, 4) + ' x ' + cleanNumber(heightValueNumber, 4) + ' in / qty ' + quantityValueNumber + ' / starts at X ' + cleanNumber(placeX, 2) + ' in, Y ' + cleanNumber(placeY, 2) + ' in');
}
}
}
if (!drawnCount) {
appendProofWarning('Customer layout proof was not generated because no multi-design previews could be drawn.');
if (diagnosticProperty) diagnosticProperty.value = 'Multi-layout proof failed: no PNG copies drawn.';
return false;
}
var diagnosticLines = [
'Mode: multi / source: multi-file PNG data URLs',
'Sheet: ' + sheet.width + ' x ' + sheet.height + ' in / print area: ' + cleanNumber(printArea.width, 2) + ' x ' + cleanNumber(printArea.height, 2) + ' in / edge: ' + cleanNumber(edge, 2) + ' in',
'Uploaded files drawn: ' + uploadedCount + ' / copies placed: ' + placedCount + ' / copies drawn: ' + drawnCount + ' / overflow: ' + overflowCount,
placementLines.join(' || ')
];
if (diagnosticProperty) {
diagnosticProperty.value = diagnosticLines.join(' | ');
}
if (multiPlacementProperty && placementLines.length) {
multiPlacementProperty.value = placementLines.join(' | ');
}
var timestamp = Date.now();
var proofFile = await canvasToPngFile(canvas, 'far-multi-design-layout-proof-' + sheet.width + 'x' + sheet.height + '-' + timestamp + '.png');
var attached = attachProofFile(proofFile);
if (layoutProofNoteProperty) {
layoutProofNoteProperty.value = 'Browser-rendered multi-design customer layout proof for FAR review. Original uploaded PNG files remain the production source.';
}
if (!attached) {
appendProofWarning('Customer layout proof could not be attached by this browser.');
}
return attached;
}
function ensureJsPdf() {
return new Promise(function (resolve, reject) {
if (window.jspdf && window.jspdf.jsPDF) {
resolve(window.jspdf.jsPDF);
return;
}
var existing = document.querySelector('script[data-far-jspdf-loader]');
if (existing) {
existing.addEventListener('load', function () {
if (window.jspdf && window.jspdf.jsPDF) {
resolve(window.jspdf.jsPDF);
} else {
reject(new Error('PDF generator loaded but was unavailable.'));
}
});
existing.addEventListener('error', function () {
reject(new Error('PDF generator failed to load.'));
});
return;
}
var script = document.createElement('script');
script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
script.async = true;
script.defer = true;
script.setAttribute('data-far-jspdf-loader', 'true');
script.onload = function () {
if (!window.jspdf || !window.jspdf.jsPDF) {
reject(new Error('PDF generator unavailable after load.'));
return;
}
resolve(window.jspdf.jsPDF);
};
script.onerror = function () {
reject(new Error('PDF generator failed to load.'));
};
document.head.appendChild(script);
});
}
function attachProductionPdfFile(file) {
if (!productionPdfInput || !file || !window.DataTransfer) return false;
var transfer = new DataTransfer();
transfer.items.add(file);
productionPdfInput.files = transfer.files;
return productionPdfInput.files && productionPdfInput.files.length > 0;
}
function pdfBlobToFile(pdf, filename) {
var blob = pdf.output('blob');
return new File([blob], filename, { type: 'application/pdf' });
}
async function buildSingleProductionSource() {
var source = root.dataset.farDtfStableDataUrl || root.dataset.farDtfLayoutUrl || root.dataset.farDtfPreviewUrl || '';
if (!source) return '';
if (root.dataset.farDtfProductionDataUrl) {
return root.dataset.farDtfProductionDataUrl;
}
try {
var production = await buildTrimmedPngPreview(source, 6000);
root.dataset.farDtfProductionDataUrl = production && production.url ? production.url : source;
return root.dataset.farDtfProductionDataUrl;
} catch (error) {
root.dataset.farDtfProductionDataUrl = source;
return source;
}
}
function readMultiProductionDataUrl(fileInput, file) {
return new Promise(function (resolve) {
var slot = fileInput ? fileInput.getAttribute('data-slot-index') || '' : '';
if (!slot || !file || fileExtension(file.name) !== 'png' || !window.FileReader) {
resolve('');
return;
}
if (multiProductionDataUrls[slot]) {
resolve(multiProductionDataUrls[slot]);
return;
}
var reader = new FileReader();
reader.onload = function () {
var result = typeof reader.result === 'string' ? reader.result : '';
if (!result) {
resolve('');
return;
}
buildTrimmedPngPreview(result, 6000)
.then(function (trimmed) {
multiProductionDataUrls[slot] = trimmed && trimmed.url ? trimmed.url : result;
resolve(multiProductionDataUrls[slot]);
})
.catch(function () {
multiProductionDataUrls[slot] = result;
resolve(result);
});
};
reader.onerror = function () {
resolve('');
};
reader.readAsDataURL(file);
});
}
function addPngToPdf(pdf, imageSrc, x, y, width, height) {
if (!imageSrc || !width || !height) return false;
try {
pdf.addImage(imageSrc, 'PNG', x, y, width, height, undefined, 'FAST');
return true;
} catch (error) {
return false;
}
}
async function generateSingleOrRepeatProductionPdf(jsPDFConstructor) {
var mode = selectedLayoutMode();
var sheet = getSelectedSheetSize(root);
var art = getArtworkSize(root);
var gap = getSelectedGapInches(root);
var edge = edgeMarginInchesSetting;
var safeArea = getSafeArea(sheet, edge);
var source = await buildSingleProductionSource();
if (!source || !art.width || !art.height) {
appendProofWarning('FAR print-ready production PDF was not generated because artwork size or source file was incomplete.');
return false;
}
var pdf = new jsPDFConstructor({
orientation: sheet.height >= sheet.width ? 'portrait' : 'landscape',
unit: 'in',
format: [sheet.width, sheet.height],
compress: true
});
pdf.setProperties({
title: 'FAR Print Shop Production Sheet ' + sheet.width + 'x' + sheet.height,
subject: 'DTF gang sheet production file',
creator: 'FAR Print Shop'
});
var drawn = 0;
if (mode === 'repeat') {
var cols = Math.max(0, Math.floor((safeArea.width + gap) / (art.width + gap)));
var rows = Math.max(0, Math.floor((safeArea.height + gap) / (art.height + gap)));
var capacity = cols * rows;
var placed = capacity;
var requestedQuantity = art.quantity;
if (selectedRepeatBehavior() === 'Use exact requested quantity' && requestedQuantity > 0) {
placed = Math.min(capacity, requestedQuantity);
}
var placedCount = 0;
for (var row = 0; row < rows; row += 1) {
for (var col = 0; col < cols; col += 1) {
if (placedCount >= placed) break;
var x = edge + col * (art.width + gap);
var y = edge + row * (art.height + gap);
if (addPngToPdf(pdf, source, x, y, art.width, art.height)) {
drawn += 1;
}
placedCount += 1;
}
}
} else {
if (addPngToPdf(pdf, source, edge, edge, art.width, art.height)) {
drawn = 1;
}
}
if (!drawn) {
appendProofWarning('FAR print-ready production PDF could not draw the PNG artwork.');
return false;
}
var timestamp = Date.now();
var filename = 'far-production-sheet-' + mode + '-' + sheet.width + 'x' + sheet.height + '-' + timestamp + '.pdf';
var file = pdfBlobToFile(pdf, filename);
var attached = attachProductionPdfFile(file);
if (productionPdfNoteProperty) {
productionPdfNoteProperty.value = 'Generated browser-side FAR production PDF from customer PNG layout. Sheet size: ' + sheet.width + ' x ' + sheet.height + ' in. Mode: ' + mode + '. Original PNG remains attached as source.';
}
if (!attached) {
appendProofWarning('FAR print-ready production PDF could not be attached by this browser.');
}
return attached;
}
async function generateMultiProductionPdf(jsPDFConstructor) {
updateMultiBoard();
var sheet = getSelectedSheetSize(root);
var edge = edgeMarginInchesSetting;
var printArea = getSafeArea(sheet, edge);
var gap = getSelectedGapInches(root);
var pdf = new jsPDFConstructor({
orientation: sheet.height >= sheet.width ? 'portrait' : 'landscape',
unit: 'in',
format: [sheet.width, sheet.height],
compress: true
});
pdf.setProperties({
title: 'FAR Print Shop Multi-Design Production Sheet ' + sheet.width + 'x' + sheet.height,
subject: 'DTF gang sheet production file',
creator: 'FAR Print Shop'
});
var cursorX = 0;
var cursorY = 0;
var rowHeight = 0;
var drawn = 0;
var overflowCount = 0;
var placementLines = [];
for (var index = 0; index < multiFiles.length; index += 1) {
var fileInput = multiFiles[index];
var file = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
var slot = fileInput.getAttribute('data-slot-index') || String(index + 1);
var slotRoot = root.querySelector('[data-far-dtf-design-slot][data-slot-index="' + slot + '"]');
var widthInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-width]') : null;
var heightInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-height]') : null;
var quantityInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-quantity]') : null;
var xInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-x]') : null;
var yInput = slotRoot ? slotRoot.querySelector('[data-far-dtf-multi-y]') : null;
if (file && fileExtension(file.name) === 'png') {
await readMultiPreviewDataUrl(fileInput, file);
syncMultiSlotProportionalSize(slotRoot);
}
var widthValueNumber = getNumber(widthInput);
var heightValueNumber = getNumber(heightInput);
var quantityValueNumber = Math.max(0, Math.floor(getNumber(quantityInput)));
var xValue = xInput && xInput.value !== '' ? Math.max(0, Number(xInput.value) || 0) : null;
var yValue = yInput && yInput.value !== '' ? Math.max(0, Number(yInput.value) || 0) : null;
if (!file || fileExtension(file.name) !== 'png' || !widthValueNumber || !heightValueNumber || !quantityValueNumber) {
continue;
}
var source = await readMultiProductionDataUrl(fileInput, file);
if (!source) continue;
var manualStart = xValue !== null || yValue !== null;
var startX = manualStart ? clampNumber(xValue || 0, 0, Math.max(0, printArea.width - widthValueNumber)) : cursorX;
var startY = manualStart ? clampNumber(yValue || 0, 0, Math.max(0, printArea.height - heightValueNumber)) : cursorY;
for (var copyIndex = 1; copyIndex <= quantityValueNumber; copyIndex += 1) {
var placeX;
var placeY;
if (manualStart) {
var copiesPerRow = Math.max(1, Math.floor((printArea.width - startX + gap) / (widthValueNumber + gap)));
var localCol = (copyIndex - 1) % copiesPerRow;
var localRow = Math.floor((copyIndex - 1) / copiesPerRow);
placeX = startX + localCol * (widthValueNumber + gap);
placeY = startY + localRow * (heightValueNumber + gap);
} else {
if (cursorX + widthValueNumber > printArea.width && cursorX > 0) {
cursorX = 0;
cursorY += rowHeight + gap;
rowHeight = 0;
}
placeX = cursorX;
placeY = cursorY;
cursorX += widthValueNumber + gap;
rowHeight = Math.max(rowHeight, heightValueNumber);
}
if (placeX + widthValueNumber > printArea.width || placeY + heightValueNumber > printArea.height) {
overflowCount += 1;
}
if (addPngToPdf(pdf, source, edge + placeX, edge + placeY, widthValueNumber, heightValueNumber)) {
drawn += 1;
}
if (copyIndex === 1) {
placementLines.push('Artwork ' + slot + ': ' + cleanNumber(widthValueNumber, 4) + ' x ' + cleanNumber(heightValueNumber, 4) + ' in / qty ' + quantityValueNumber + ' / starts at X ' + cleanNumber(placeX, 2) + ' in, Y ' + cleanNumber(placeY, 2) + ' in');
}
}
}
if (!drawn) {
appendProofWarning('FAR print-ready production PDF was not generated because no multi-design PNG files could be drawn.');
return false;
}
if (overflowCount > 0) {
appendProofWarning('FAR print-ready production PDF generated, but one or more copies may exceed the selected print area.');
}
var timestamp = Date.now();
var filename = 'far-production-sheet-multi-' + sheet.width + 'x' + sheet.height + '-' + timestamp + '.pdf';
var file = pdfBlobToFile(pdf, filename);
var attached = attachProductionPdfFile(file);
if (productionPdfNoteProperty) {
productionPdfNoteProperty.value = 'Generated browser-side FAR multi-design production PDF from customer PNG files. Sheet size: ' + sheet.width + ' x ' + sheet.height + ' in. Copies drawn: ' + drawn + '. Original PNG files remain attached as production sources.';
}
if (multiPlacementProperty && placementLines.length) {
multiPlacementProperty.value = placementLines.join(' | ');
}
if (!attached) {
appendProofWarning('FAR print-ready production PDF could not be attached by this browser.');
}
return attached;
}
async function generateProductionPdfForPngWorkflow() {
var mode = selectedLayoutMode();
var sheet = getSelectedSheetSize(root);
var primaryFile = input && input.files && input.files[0] ? input.files[0] : null;
var skipForPayloadSafety = Boolean(
sheet.custom ||
(primaryFile && primaryFile.size > 8 * 1024 * 1024)
);
if (mode === 'pdf') {
if (productionPdfNoteProperty) {
productionPdfNoteProperty.value = 'Production PDF generation skipped because customer supplied a print-ready PDF.';
}
return false;
}
if (skipForPayloadSafety) {
appendProofWarning('Duplicate browser-generated production PDF was skipped to prevent Shopify request-size errors. Original uploaded artwork remains the production source.');
if (productionPdfNoteProperty) {
productionPdfNoteProperty.value = 'Production PDF generation skipped for payload safety. Sheet size: ' + sheet.width + ' x ' + sheet.height + ' in. Original uploaded artwork remains attached as the production source.';
}
if (productionPdfInput && window.DataTransfer) {
productionPdfInput.files = new DataTransfer().files;
}
return false;
}
try {
var jsPDFConstructor = await ensureJsPdf();
if (mode === 'multi') {
return await generateMultiProductionPdf(jsPDFConstructor);
}
return await generateSingleOrRepeatProductionPdf(jsPDFConstructor);
} catch (error) {
appendProofWarning('FAR print-ready production PDF could not be generated in this browser. Original uploaded artwork files were still submitted.');
if (productionPdfNoteProperty) {
productionPdfNoteProperty.value = 'Production PDF generation failed in browser. Original uploaded artwork files remain attached.';
}
return false;
}
}
async function generateCustomerLayoutProof() {
if (!layoutProofInput) return false;
var mode = selectedLayoutMode();
if (mode !== 'multi' && !getArtworkPreviewSource(root)) return false;
if (mode === 'pdf') {
if (layoutProofNoteProperty) {
layoutProofNoteProperty.value = 'No rendered PNG proof generated for print-ready PDF workflow. Customer supplied a designer-arranged PDF for FAR production review.';
}
if (diagnosticProperty) {
diagnosticProperty.value = 'Proof skipped: print-ready PDF mode.';
}
return false;
}
if (mode === 'multi') {
return generateMultiDesignLayoutProof();
}
updateAutoHeightState();
var sheet = getSelectedSheetSize(root);
var art = getArtworkSize(root);
var gap = getSelectedGapInches(root);
var edge = edgeMarginInchesSetting;
var safeArea = getSafeArea(sheet, edge);
var proofSource = getArtworkPreviewSource(root);
var sourceType = proofSource === root.dataset.farDtfLayoutUrl ? 'trimmed layout data URL' : 'original object URL';
if (!art.width || !art.height) {
appendProofWarning('Customer layout proof was not generated because artwork width/height was incomplete.');
if (diagnosticProperty) diagnosticProperty.value = 'Layout proof failed: artwork width/height incomplete.';
return false;
}
var canvasSize = getProofCanvasSize(sheet);
var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
if (!ctx) {
appendProofWarning('Customer layout proof was not generated because canvas rendering was unavailable.');
if (diagnosticProperty) diagnosticProperty.value = 'Layout proof failed: canvas unavailable.';
return false;
}
canvas.width = canvasSize.width;
canvas.height = canvasSize.height;
var ppi = drawProofGrid(ctx, canvas.width, canvas.height, sheet);
var image;
var imageLoaded = false;
var imageError = '';
try {
image = await loadImageForProof(proofSource);
imageLoaded = Boolean(image && (image.naturalWidth || image.width));
} catch (error) {
imageLoaded = false;
imageError = error && error.message ? error.message : 'Unknown image load failure.';
appendProofWarning('Customer layout proof could not load artwork image.');
}
var artPxW = art.width * ppi;
var artPxH = art.height * ppi;
var gapPx = gap * ppi;
var edgePx = edge * ppi;
var cols = 0;
var rows = 0;
var capacity = 0;
var placed = 0;
var drawn = 0;
drawSafeArea(ctx, ppi, sheet, edge);
if (imageLoaded) {
drawSourceSample(ctx, image, canvas.width, canvas.height);
} else {
drawDiagnosticPill(ctx, canvas.width - 330, 24, 'SOURCE SAMPLE: IMAGE FAILED', 'rgba(238, 54, 54, 0.96)', '#ffffff');
}
if (mode === 'repeat') {
cols = Math.max(0, Math.floor((safeArea.width + gap) / (art.width + gap)));
rows = Math.max(0, Math.floor((safeArea.height + gap) / (art.height + gap)));
capacity = cols * rows;
var repeatBehavior = selectedRepeatBehavior();
var requestedQuantity = art.quantity;
placed = capacity;
if (repeatBehavior === 'Use exact requested quantity' && requestedQuantity > 0) {
placed = Math.min(capacity, requestedQuantity);
}
var placedCount = 0;
for (var row = 0; row < rows; row += 1) {
for (var col = 0; col < cols; col += 1) {
if (placedCount >= placed) break;
var x = edgePx + col * (artPxW + gapPx);
var y = edgePx + row * (artPxH + gapPx);
var tileLabel = 'T' + (placedCount + 1);
if (imageLoaded && drawProofArtwork(ctx, image, x, y, artPxW, artPxH, tileLabel)) {
drawn += 1;
} else {
ctx.save();
ctx.strokeStyle = 'rgba(238, 54, 54, 0.98)';
ctx.lineWidth = 3;
ctx.strokeRect(x, y, artPxW, artPxH);
drawDiagnosticPill(ctx, x + 4, y + 4, tileLabel + ': IMAGE NOT DRAWN', 'rgba(238, 54, 54, 0.96)', '#ffffff');
ctx.restore();
}
placedCount += 1;
}
}
} else {
placed = 1;
capacity = 1;
if (imageLoaded && drawProofArtwork(ctx, image, edgePx, edgePx, artPxW, artPxH, 'SINGLE')) {
drawn = 1;
}
}
var diagnosticLines = [
'Mode: ' + mode + ' / source: ' + sourceType,
'Image loaded: ' + (imageLoaded ? 'YES' : 'NO') + (imageLoaded ? ' / ' + (image.naturalWidth || image.width) + 'x' + (image.naturalHeight || image.height) + 'px' : ' / ' + imageError),
'Artwork box: ' + cleanNumber(art.width, 4) + ' in W x ' + cleanNumber(art.height, 4) + ' in H / gap: ' + cleanNumber(gap, 2) + ' in',
'Sheet: ' + sheet.width + ' x ' + sheet.height + ' in / safe: ' + cleanNumber(safeArea.width, 2) + ' x ' + cleanNumber(safeArea.height, 2) + ' in / edge: ' + cleanNumber(edge, 2) + ' in',
'Tiles: cols ' + cols + ' / rows ' + rows + ' / placed ' + placed + ' / drawn ' + drawn + ' / ppi ' + Math.round(ppi),
'Trim: ' + (root.dataset.farDtfTrimmedArtwork === 'true' ? 'YES' : 'NO') + ' / trim px ' + (root.dataset.farDtfTrimWidth || '0') + 'x' + (root.dataset.farDtfTrimHeight || '0')
];
drawProofLabel(ctx, sheet, diagnosticLines);
var diagnosticStatus = diagnosticLines.join(' | ');
if (diagnosticProperty) {
diagnosticProperty.value = diagnosticStatus;
}
var timestamp = Date.now();
var proofFile = await canvasToPngFile(canvas, 'far-customer-layout-proof-' + sheet.width + 'x' + sheet.height + '-' + timestamp + '.png');
var attached = attachProofFile(proofFile);
if (layoutProofNoteProperty) {
layoutProofNoteProperty.value = 'Browser-rendered customer layout proof for FAR review. Original uploaded PNG remains the production source.';
}
if (!attached) {
appendProofWarning('Customer layout proof could not be attached by this browser.');
}
return attached;
}
function submitFormAfterProof() {
if (!productForm) return;
if (typeof productForm.requestSubmit === 'function') {
productForm.requestSubmit();
return;
}
if (typeof productForm.submit === 'function') {
productForm.submit();
}
}
function getActiveUploadPayloadBytes() {
var mode = selectedLayoutMode();
var bytes = 0;
if (mode === 'pdf') {
if (pdfInput && pdfInput.files && pdfInput.files[0]) {
bytes += pdfInput.files[0].size || 0;
}
return bytes;
}
if (mode === 'multi') {
multiFiles.forEach(function (fileInput) {
if (fileInput && fileInput.files && fileInput.files[0]) {
bytes += fileInput.files[0].size || 0;
}
});
return bytes;
}
if (input && input.files && input.files[0]) {
bytes += input.files[0].size || 0;
}
return bytes;
}
function formatMegabytes(bytes) {
return (Number(bytes || 0) / (1024 * 1024)).toFixed(1).replace(/\.0$/, '') + ' MB';
}
async function handleProofSubmit(event) {
if (!productForm || isSubmittingWithProof) return;
var mode = selectedLayoutMode();
var customState = updateCustomSheetState();
var activePayloadBytes = getActiveUploadPayloadBytes();
var maxSafeUploadBytes = 20 * 1024 * 1024;
if (activePayloadBytes > maxSafeUploadBytes) {
event.preventDefault();
event.stopPropagation();
appendProofWarning('Uploaded file payload is too large for Shopify cart submission. Compress the file or use the print-ready PDF workflow.');
if (submitText) {
submitText.textContent = 'File too large';
}
if (uploadStatus && mode !== 'pdf' && mode !== 'multi') {
uploadStatus.textContent = 'This file is ' + formatMegabytes(activePayloadBytes) + '. Shopify may reject files over about ' + formatMegabytes(maxSafeUploadBytes) + '. Export a smaller PNG or use the print-ready PDF workflow.';
}
if (pdfStatus && mode === 'pdf') {
pdfStatus.textContent = 'This PDF is ' + formatMegabytes(activePayloadBytes) + '. Shopify may reject oversized files. Compress the PDF before adding to cart.';
}
if (mode === 'multi') {
setTextAndClass(multiPanelEstimate, 'The selected artwork files total ' + formatMegabytes(activePayloadBytes) + '. Compress files before checkout to avoid Shopify request-size errors.', true);
}
return;
}
if (customState.active && !customState.valid) {
event.preventDefault();
event.stopPropagation();
if (submitText) {
submitText.textContent = 'Enter custom height';
}
if (customSheetStatus) {
customSheetStatus.textContent = customState.invalidIncrement ? halfInchOnlyMessage() : 'Enter a whole- or half-inch custom height from 22 x ' + cleanNumber(customSheetMinHeight, 1) + ' through 22 x ' + cleanNumber(customSheetMaxHeight, 1) + ' in. Sizes through 22 x 36 use the minimum charge.';
customSheetStatus.classList.add('is-warning');
}
if (customSheetWrap) {
customSheetWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
return;
}
if (customState.active && root.dataset.farDtfCustomVariantValid !== 'true') {
event.preventDefault();
event.stopPropagation();
if (submitText) {
submitText.textContent = 'Custom size unavailable';
}
if (customSheetStatus) {
customSheetStatus.textContent = 'Create and price the matching Shopify variant before selling custom heights above ' + cleanNumber(customSheetMinimumBillableHeight, 1) + ' in. Sizes through 22 x 36 use the existing minimum-charge variant.';
customSheetStatus.classList.add('is-warning');
}
if (customSheetWrap) {
customSheetWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
return;
}
var dpiState = updateDpiPreflight();
if (dpiState.low && !dpiState.approved) {
event.preventDefault();
event.stopPropagation();
if (submitText) {
submitText.textContent = 'Approve resolution warning';
}
if (dpiPanel) {
dpiPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
return;
}
if (hasInvalidUpload) {
event.preventDefault();
event.stopPropagation();
if (submitText) {
submitText.textContent = mode === 'pdf' ? 'Upload PDF only' : 'Upload PNG only';
}
if (mode === 'pdf') {
if (pdfStatus) pdfStatus.textContent = 'Only PDF files are accepted in print-ready PDF mode.';
} else if (mode === 'multi') {
setTextAndClass(multiPanelEstimate, 'Only transparent PNG files are accepted for multiple-design production. Replace the unsupported file before checkout.', true);
if (multiPanel) multiPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
} else if (uploadStatus) {
uploadStatus.textContent = 'Only transparent PNG files are accepted. Please remove the current file and upload a PNG.';
}
return;
}
if (mode === 'multi' && hasIncompleteMultiDetails) {
event.preventDefault();
event.stopPropagation();
if (submitText) {
submitText.textContent = 'Complete design details';
}
setTextAndClass(multiPanelEstimate, 'Complete width, height, and quantity for every uploaded PNG before adding this gang sheet to cart.', true);
if (multiPanel) {
multiPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
return;
}
if (mode === 'pdf') return;
if (mode !== 'multi' && !getArtworkPreviewSource(root)) return;
event.preventDefault();
event.stopPropagation();
isSubmittingWithProof = true;
if (submitButton) {
submitButton.disabled = true;
}
if (submitText) {
submitText.textContent = 'Creating layout proof...';
}
try {
await generateCustomerLayoutProof();
} catch (error) {
appendProofWarning('Customer layout proof failed to generate. Original PNG artwork and production details were still submitted.');
}
if (submitText) {
submitText.textContent = 'Creating production PDF...';
}
try {
await generateProductionPdfForPngWorkflow();
} catch (error) {
appendProofWarning('FAR print-ready production PDF failed to generate. Original uploaded artwork files were still submitted.');
}
if (submitText) {
submitText.textContent = 'Adding to cart...';
}
submitFormAfterProof();
}
if (input) {
input.addEventListener('change', function () {
var file = input.files && input.files[0] ? input.files[0] : null;
if (!file) {
resetPreview();
return;
}
var ext = fileExtension(file.name);
var mime = file.type || '';
var isPreviewableImage = mime.indexOf('image/') === 0 && ext === 'png';
var sizeMb = file.size ? (file.size / 1024 / 1024) : 0;
if (uploadControl) uploadControl.classList.add('has-file');
if (uploadTitle) uploadTitle.textContent = truncateFilename(file.name);
if (heightOverrideInput) heightOverrideInput.checked = false;
if (!isPreviewableImage) {
hasInvalidUpload = true;
revokePreviewUrl(root);
if (uploadText) uploadText.textContent = 'Unsupported file. PNG only.';
if (uploadStatus) {
uploadStatus.textContent = 'Only transparent PNG files are accepted for this product. Please upload a PNG file.';
}
showFallback(file, 'Only transparent PNG files are accepted for this product. Please upload a PNG so FAR can generate the live sheet preview and customer layout proof.');
return;
}
hasInvalidUpload = false;
if (uploadText) {
uploadText.textContent = 'PNG preview loaded. Default width is ' + cleanNumber(defaultArtworkWidthInches, 2) + ' in. Height auto-calculates from the uploaded artwork ratio.';
}
if (uploadStatus) {
uploadStatus.textContent = 'PNG artwork file attached: ' + file.name + (sizeMb ? ' / ' + sizeMb.toFixed(1) + ' MB' : '');
}
showImagePreview(file);
});
}
if (artworkWidthInput) {
artworkWidthInput.addEventListener('input', function () {
dimensionDriver = 'width';
enforceMinimumArtworkSize(artworkWidthInput);
updateAutoHeightState();
applyCurrentPhysicalPreview();
});
artworkWidthInput.addEventListener('change', function () {
dimensionDriver = 'width';
enforceMinimumArtworkSize(artworkWidthInput);
updateAutoHeightState();
applyCurrentPhysicalPreview();
});
}
if (artworkHeightInput) {
artworkHeightInput.addEventListener('input', function () {
dimensionDriver = 'height';
enforceMinimumArtworkSize(artworkHeightInput);
updateAutoHeightState();
applyCurrentPhysicalPreview();
});
artworkHeightInput.addEventListener('change', function () {
dimensionDriver = 'height';
enforceMinimumArtworkSize(artworkHeightInput);
updateAutoHeightState();
applyCurrentPhysicalPreview();
});
}
if (heightOverrideInput) {
heightOverrideInput.addEventListener('change', function () {
dimensionDriver = heightOverrideInput.checked ? 'height' : 'width';
updateAutoHeightState();
applyCurrentPhysicalPreview();
});
}
if (dpiApprovalInput) {
dpiApprovalInput.addEventListener('change', updateDpiPreflight);
}
[quantityInput, gapInput, repeatModeInput].forEach(function (field) {
if (!field) return;
field.addEventListener('input', applyCurrentPhysicalPreview);
field.addEventListener('change', applyCurrentPhysicalPreview);
});
if (pdfInput) {
pdfInput.addEventListener('change', async function () {
if (pdfObjectUrl) { URL.revokeObjectURL(pdfObjectUrl); pdfObjectUrl = ''; }
lastPdfRenderToken = '';
var file = pdfInput.files && pdfInput.files[0] ? pdfInput.files[0] : null;
if (file && fileExtension(file.name) === 'pdf') {
if (pdfStatus) {
pdfStatus.textContent = 'PDF received. Reading page size before preview render...';
}
await detectAndApplyPdfSheetSize(file);
}
updatePdfMode();
});
}
multiFiles.forEach(function (fileInput) {
fileInput.addEventListener('change', function () {
var slot = fileInput.getAttribute('data-slot-index') || '';
if (slot && multiPreviewDataUrls[slot]) delete multiPreviewDataUrls[slot];
if (slot && multiProductionDataUrls[slot]) delete multiProductionDataUrls[slot];
if (slot && multiPreviewRatios[slot]) delete multiPreviewRatios[slot];
if (slot && multiPreviewTrimmed[slot]) delete multiPreviewTrimmed[slot];
showMultiMode();
updateDpiPreflight();
});
});
multiFields.forEach(function (field) {
function handleMultiFieldChange() {
var slotRoot = field.closest ? field.closest('[data-far-dtf-design-slot]') : null;
if (slotRoot && field.matches && field.matches('[data-far-dtf-multi-width]')) {
syncMultiSlotProportionalSize(slotRoot, 'width');
}
if (slotRoot && field.matches && field.matches('[data-far-dtf-multi-height]')) {
syncMultiSlotProportionalSize(slotRoot, 'height');
}
updateMultiBoard();
}
field.addEventListener('input', handleMultiFieldChange);
field.addEventListener('change', handleMultiFieldChange);
});
layoutInputs.forEach(function (input) {
input.addEventListener('change', function () {
syncSourceUIFromMode();
setFormMode();
});
});
sourceInputs.forEach(function (sourceInput) {
sourceInput.addEventListener('change', function () {
if (!sourceInput.checked) return;
var sourceMode = sourceInput.getAttribute('data-source-mode');
if (sourceMode === 'pdf') {
setLayoutMode('pdf');
return;
}
if (selectedLayoutMode() === 'pdf') {
setLayoutMode('single');
return;
}
setFormMode();
});
});
sheetSizeSelects.forEach(function (select) {
select.addEventListener('change', function () {
selectSheetSizeFromDropdown(select);
syncSheetSizeSelectsFromRadios();
});
});
if (customSheetToggle) {
customSheetToggle.addEventListener('change', function () {
updateCustomSheetState();
scheduleSheetGeometry();
refreshPreview();
root.dispatchEvent(new CustomEvent('far-dtf:custom-sheet-change', { bubbles: true }));
});
}
if (customHeightInput) {
customHeightInput.addEventListener('input', function () {
updateCustomSheetState();
scheduleSheetGeometry();
refreshPreview();
root.dispatchEvent(new CustomEvent('far-dtf:custom-sheet-change', { bubbles: true }));
});
customHeightInput.addEventListener('blur', function () {
if (!customSheetToggle || !customSheetToggle.checked || customHeightInput.value === '') return;
var value = Number(customHeightInput.value);
if (Number.isFinite(value)) {
customHeightInput.value = cleanNumber(Math.max(customSheetMinHeight, Math.min(customSheetMaxHeight, snapToHalfInch(value))), 1);
}
updateCustomSheetState();
scheduleSheetGeometry();
refreshPreview();
root.dispatchEvent(new CustomEvent('far-dtf:custom-sheet-change', { bubbles: true }));
});
}
if (clearButton) {
clearButton.addEventListener('click', resetPreview);
}
if (productForm) {
productForm.addEventListener('submit', handleProofSubmit, true);
}
window.addEventListener('resize', function () {
window.clearTimeout(resizeTimer);
resizeTimer = window.setTimeout(function () {
scheduleSheetGeometry();
refreshPreview();
}, 120);
});
updateCustomSheetState();
setFormMode();
updateAutoHeightState();
scheduleSheetGeometry();
return {
refreshSheetRatio: scheduleSheetGeometry,
refreshPreview: refreshPreview
};
}
function initFarDtfGangSection(root) {
if (!root || root.dataset.farDtfGangInitialized === 'true') return;
root.dataset.farDtfGangInitialized = 'true';
var variantsScript = root.querySelector('[data-far-dtf-variants-json]');
var variantInput = root.querySelector('[data-far-dtf-variant-id]');
var optionInputs = root.querySelectorAll('[data-far-dtf-option-input]');
var priceEl = root.querySelector('[data-far-dtf-price]');
var compareEl = root.querySelector('[data-far-dtf-compare]');
var submitButton = root.querySelector('[data-far-dtf-submit]');
var submitText = root.querySelector('[data-far-dtf-submit-text]');
var statusEl = root.querySelector('[data-far-dtf-status]');
var customSheetToggle = root.querySelector('[data-far-dtf-custom-sheet-toggle]');
var customHeightInput = root.querySelector('[data-far-dtf-custom-height]');
var artworkPreview = initArtworkPreview(root);
if (!variantsScript || !variantInput) return;
var variants = [];
var moneyFormat = root.getAttribute('data-money-format') || config.moneyFormat;
var availableNote = config.availableNote;
var unavailableNote = config.unavailableNote;
var soldOutLabel = config.soldOutLabel;
var addToCartLabel = config.addToCartLabel;
try {
variants = JSON.parse(variantsScript.textContent || '[]');
} catch (error) {
variants = [];
}
function getSelectedOptions() {
var groups = root.querySelectorAll('[data-far-dtf-option-group]');
var selected = [];
groups.forEach(function (group) {
var checked = group.querySelector('[data-far-dtf-option-input]:checked');
if (checked) selected.push(checked.value);
});
return selected;
}
function customSheetPricingEnabled() {
return Boolean(customSheetToggle && customSheetToggle.checked);
}
function getCustomHeightEntryState() {
var rawText = customHeightInput ? String(customHeightInput.value || '').trim() : '';
var rawValue = rawText === '' ? 0 : Number(rawText);
var halfInchValue = Number.isFinite(rawValue) ? snapToHalfInch(rawValue) : 0;
var active = customSheetPricingEnabled();
var isHalfInch = isHalfInchText(rawText);
var invalidIncrement = rawText !== '' && Number.isFinite(rawValue) && !isHalfInch;
var valid = active && rawText !== '' && isHalfInch && halfInchValue >= customSheetMinHeight && halfInchValue <= customSheetMaxHeight;
var focused = Boolean(customHeightInput && document.activeElement === customHeightInput);
var partialBelowMinimum = Boolean(active && focused && rawText !== '' && Number.isFinite(rawValue) && rawValue > 0 && rawValue < customSheetMinHeight);
return {
active: active,
rawText: rawText,
rawValue: rawValue,
halfInchValue: halfInchValue,
valid: valid,
focused: focused,
partialBelowMinimum: partialBelowMinimum,
invalidIncrement: invalidIncrement,
isHalfInch: isHalfInch
};
}
function getHalfInchCustomHeightForVariant() {
var state = getCustomHeightEntryState();
if (!state.valid) return 0;
return Math.max(customSheetMinHeight, Math.min(customSheetMaxHeight, state.halfInchValue));
}
function getVariantSheetSize(variant) {
var options = variant && variant.options ? variant.options : [];
for (var index = 0; index < options.length; index += 1) {
var parsedOption = parseSheetSizeFromValue(options[index]);
if (parsedOption) return parsedOption;
}
return parseSheetSizeFromValue(variant ? variant.title : '');
}
function findHalfInchCustomVariant() {
var requestedHeight = getHalfInchCustomHeightForVariant();
if (!customSheetPricingEnabled() || !requestedHeight || !variants.length) return null;
var minimumBillableHeight = Number(customSheetMinimumBillableHeight || 36);
if (!Number.isFinite(minimumBillableHeight) || minimumBillableHeight <= 0) {
minimumBillableHeight = 36;
}
var billableHeight = requestedHeight <= minimumBillableHeight ? minimumBillableHeight : requestedHeight;
return variants.find(function (variant) {
var size = getVariantSheetSize(variant);
if (!size) return false;
return Math.abs(size.width - 22) < 0.001 && Math.abs(size.height - billableHeight) < 0.001;
}) || null;
}
function findVariant() {
if (!variants.length) return null;
if (customSheetPricingEnabled()) {
return findHalfInchCustomVariant();
}
var selected = getSelectedOptions();
if (!selected.length) {
return variants.find(function (variant) {
return String(variant.id) === String(variantInput.value);
}) || variants[0];
}
return variants.find(function (variant) {
if (!variant.options || variant.options.length !== selected.length) return false;
return variant.options.every(function (optionValue, index) {
return String(optionValue) === String(selected[index]);
});
});
}
function updateVariant() {
if (customSheetPricingEnabled()) {
var customEntryState = getCustomHeightEntryState();
if (!customEntryState.valid) {
root.dataset.farDtfCustomVariantValid = 'false';
if (submitButton) submitButton.disabled = true;
if (submitText) submitText.textContent = 'Enter custom height';
if (statusEl) {
if (customEntryState.rawText === '') {
statusEl.textContent = 'Enter a whole- or half-inch custom height. Sizes through 22 x 36 use the minimum price; 22 x 36.5 and higher use matching Shopify variants.';
} else if (customEntryState.invalidIncrement) {
statusEl.textContent = halfInchOnlyMessage();
} else if (customEntryState.rawValue < customSheetMinHeight) {
statusEl.textContent = 'Continue entering the height or use a whole- or half-inch size from 22 x ' + cleanNumber(customSheetMinHeight, 1) + ' through 22 x ' + cleanNumber(customSheetMaxHeight, 1) + ' in.';
} else if (customEntryState.rawValue > customSheetMaxHeight) {
statusEl.textContent = 'Maximum custom height is 22 x ' + cleanNumber(customSheetMaxHeight, 1) + ' in.';
} else {
statusEl.textContent = 'Enter a valid whole- or half-inch custom height before adding to cart.';
}
}
return;
}
}
var variant = findVariant();
if (!variant) {
var missingHeight = getHalfInchCustomHeightForVariant();
var minimumBillableHeight = Number(customSheetMinimumBillableHeight || 36);
if (!Number.isFinite(minimumBillableHeight) || minimumBillableHeight <= 0) {
minimumBillableHeight = 36;
}
var billableMissingHeight = missingHeight && missingHeight <= minimumBillableHeight ? minimumBillableHeight : missingHeight;
var customMissingMessage = billableMissingHeight
? 'Custom size unavailable: create and price the Shopify variant 22 in x ' + cleanNumber(billableMissingHeight, 1) + ' in, then try again.'
: unavailableNote;
if (customSheetPricingEnabled()) {
root.dataset.farDtfCustomVariantValid = 'false';
} else {
delete root.dataset.farDtfCustomVariantValid;
}
if (submitButton) submitButton.disabled = true;
if (submitText) submitText.textContent = customSheetPricingEnabled() ? 'Custom size unavailable' : unavailableNote;
if (statusEl) statusEl.textContent = customMissingMessage;
return;
}
if (customSheetPricingEnabled()) {
root.dataset.farDtfCustomVariantValid = variant.available ? 'true' : 'false';
} else {
delete root.dataset.farDtfCustomVariantValid;
}
variantInput.value = variant.id;
if (priceEl) {
priceEl.textContent = formatMoney(variant.price, moneyFormat);
}
if (compareEl) {
if (variant.compare_at_price && variant.compare_at_price > variant.price) {
compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
compareEl.classList.remove('is-hidden');
} else {
compareEl.textContent = '';
compareEl.classList.add('is-hidden');
}
}
if (submitButton) {
submitButton.disabled = !variant.available;
}
if (submitText) {
submitText.textContent = variant.available ? addToCartLabel : soldOutLabel;
}
if (statusEl) {
if (customSheetPricingEnabled() && variant.available) {
var requestedCustomHeight = getHalfInchCustomHeightForVariant();
var minimumBillableHeight = Number(customSheetMinimumBillableHeight || 36);
if (!Number.isFinite(minimumBillableHeight) || minimumBillableHeight <= 0) {
minimumBillableHeight = 36;
}
if (requestedCustomHeight && requestedCustomHeight <= minimumBillableHeight) {
statusEl.textContent = 'Custom minimum-charge sheet selected: 22 in x ' + cleanNumber(requestedCustomHeight, 1) + ' in. Checkout uses the existing 22 in x ' + cleanNumber(minimumBillableHeight, 1) + ' in variant at the minimum price.';
} else if (requestedCustomHeight) {
statusEl.textContent = 'Custom sheet selected: 22 in x ' + cleanNumber(requestedCustomHeight, 1) + ' in. Checkout uses the matching Shopify variant price.';
} else {
statusEl.textContent = availableNote;
}
} else {
statusEl.textContent = variant.available ? availableNote : unavailableNote;
}
}
if (artworkPreview) {
artworkPreview.refreshSheetRatio();
artworkPreview.refreshPreview();
}
}
optionInputs.forEach(function (input) {
input.addEventListener('change', updateVariant);
});
if (customSheetToggle) {
customSheetToggle.addEventListener('change', updateVariant);
}
if (customHeightInput) {
customHeightInput.addEventListener('input', updateVariant);
customHeightInput.addEventListener('blur', updateVariant);
}
root.addEventListener('far-dtf:custom-sheet-change', updateVariant);
updateVariant();
}
initFarDtfGangSection(root);
root._farDtfCleanup = function () {
revokePreviewUrl(root);
root.removeAttribute('data-far-dtf-mounted');
};
}
function boot(scope) {
var context = scope && scope.querySelectorAll ? scope : document;
if (context.matches && context.matches('.far-dtf-gang[data-far-dtf-module]')) {
initRoot(context);
}
context.querySelectorAll('.far-dtf-gang[data-far-dtf-module]').forEach(initRoot);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
} else {
boot(document);
}
document.addEventListener('shopify:section:load', function (event) {
if (event && event.target) boot(event.target);
});
document.addEventListener('shopify:section:unload', function (event) {
if (!event || !event.target) return;
var root = event.target.matches && event.target.matches('.far-dtf-gang')
? event.target
: event.target.querySelector('.far-dtf-gang');
if (root && typeof root._farDtfCleanup === 'function') root._farDtfCleanup();
});
})();
